<template>
  <jw-space :size="0" direction="vertical" class="fh-form-table-space">
    <div class="table-head">
      <div class="table-title">
        <component :is="fieldIconMapping[modulesItem?.type]" style="margin-right: 8px" />
        <div class="title-label">
          <xl-label-text :value="setRecordLabel(modulesItem)" :row="1" />
        </div>
        <jw-tooltip v-if="modulesItem?.toast">
          <icon-question-circle size="18" />
          <!-- 这是提示文本  -->
          <template #content>
            {{ modulesItem.toast }}
          </template>
        </jw-tooltip>
        <qf-icon-required v-if="modulesItem.type == 30 && (modulesItem.isRequired == 1 || modulesItem?.conditionsIsRequired == 1)" />
      </div>
      <div class="add-btn-content">
        <template v-for="btn in buttons" :key="btn.value">
          <!--新建  -->
          <template v-if="isShowAddBtn(btn)">
            <!-- 批量新建 -->
            <jw-button v-if="isAllowBatchAdd" class="add-btn" type="text" size="small" @click="openListModal">
              <qfei-icon-add-two-outlined />
              {{ $t('批量添加') }}
            </jw-button>

            <jw-button class="add-btn" type="text" size="small" @click="addDetail"> <qfei-icon-add-two-outlined />{{ btn.label }} </jw-button>
          </template>
          <!-- 合同产品--添加报价单明细-->
          <template v-if="btn.value == `contractProduct:addOrderDetail`">
            <jw-button class="add-btn" type="text" size="small" @click="updateDetail(1)"> <qfei-icon-add-two-outlined />{{ btn.label }} </jw-button>
          </template>
          <!-- 销售订单产品--添加报价单明细 -->
          <template v-if="btn.value == `saleOrderProduct:addOrderDetail`">
            <jw-button class="add-btn" type="text" size="small" @click="updateDetail(2)"> <qfei-icon-add-two-outlined />{{ btn.label }} </jw-button>
          </template>
          <!-- 销售订单产品--添加合同明细 -->
          <template v-if="btn.value == `saleOrderProduct:addContractDetail`">
            <jw-button class="add-btn" type="text" size="small" @click="updateDetail(3)"> <qfei-icon-add-two-outlined />{{ btn.label }} </jw-button>
          </template>
          <!-- 退货单产品--添加明细 -->
          <template v-if="btn.value == `returnOrderProduct:add`">
            <jw-button class="add-btn" type="text" size="small" @click="addReturnOrder"> <qfei-icon-add-two-outlined />{{ btn.label }} </jw-button>
          </template>
        </template>
      </div>
    </div>
    <!-- 表格 -->
    <template v-if="modulesItem?.businessData != 14">
      <fh-table :max-height="500" header-affixed-top :pagination="null" :loading="data.tableloading" :data="detailDataList?.length ? detailDataList : [{}]" :bordered="true" :columns="tableColumns" resizable class="ly-form-record-table" :footData="detailDataList?.length ? [{}] : []">
        <template #number-slot-name="{ rowIndex }">
          <span style="color: var(--color-text-3)">{{ rowIndex + 1 }}</span>
        </template>
        <!-- 操作插槽 -->
        <template #operation="{ row, rowIndex }">
          <template v-if="detailDataList?.length">
            <!-- 关联记录 -->
            <template v-if="filteredButtons(row[0])?.length && (props.modulesItem?.type == 30 || (props.modulesItem?.type == 31 && row[0]?.LOGIC_ROLE_PERMISSION && row[0]?.LOGIC_ROLE_PERMISSION == 1))">
              <template v-for="btn in filteredButtons(row[0])" :key="btn.value">
                <!-- 编辑 -->
                <jw-link v-if="btn.value == getBtnValue('edit')" @click="editDetail(row, rowIndex)">{{ btn.label }}</jw-link>
                <!-- 删除 -->
                <jw-link v-if="btn.value == getBtnValue('delete')" @click="removeDetail(row, rowIndex)">{{ btn.label }}</jw-link>
                <!-- 复制 -->
                <jw-link v-if="btn.value == getBtnValue('copy')" @click="copyDetail(row, rowIndex)">{{ btn.label }}</jw-link>
              </template>
            </template>
            <template v-else><div class="empty-btn">-</div></template>
          </template>
        </template>
        <!-- 汇总行 -->
        <template #summaryCell="{ col }">
          <span v-if="col.colKey !== 'operation'">
            <qf-body-summary-cell :column="col" :value="getAggregationValue(col)" :aggregation-type="getAggregationType(col)" :formatter="aggregationValueFormatter" @change="aggregationChange" />
          </span>
        </template>
      </fh-table>
    </template>
    <!-- 14：退货单产品 -->
    <template v-else>
      <fh-table sticky-header :pagination="null" :data="detailDataList?.length ? detailDataList : [{}]" :bordered="true" :columns="tableColumnsReturnOrder">
        <template v-for="(item, index) in tableColumnsReturnOrder" :key="index" #[item?.colKey]="{ row, rowIndex }">
          <template v-if="!detailDataList?.length">
            <div class="empty-text">-</div>
          </template>
          <!-- 退货标准价格 -->
          <template v-else-if="item.colKey == 'standardPrice'">
            <jw-input-number :min="1" @input="(event) => getPrecisionNum(event, row[index])" :formatter="(event) => isShowThousandFormatter(event, row[index])" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(row[index], precisionNum)" :placeholder="$t('请输入')" @change="updateList($event, rowIndex, row[index])" v-model="row[index].fieldValue" />
          </template>
          <!-- 折后单价（含税） -->
          <template v-else-if="item.colKey == 'customerDiscountPrice'">
            <span>{{ row[index].fieldValue?.toFixed(Number(row[index]?.setting?.fieldExt) || 2) || '-' }}</span>
          </template>
          <!-- 折扣 -->
          <template v-else-if="item.colKey == 'customerDiscount'">
            <jw-input-number class="card-form-item-value" v-model="row[index].fieldValue" :placeholder="$t('请输入')" @input="(event) => getPrecisionNum(event, row[index])" :precision="getPrecision(row[index], precisionNum)" :min="0" @change="updateList($event, rowIndex, row[index])">
              <template #append>%</template>
            </jw-input-number>
          </template>
          <!-- 税率 -->
          <template v-else-if="item.colKey == 'taxRate'">
            <span>{{ row[index].fieldValue + '%' || '-' }}</span>
          </template>
          <!-- 币种 -->
          <template v-else-if="item.colKey == 'currencyType'">
            <jw-select :trigger-props="{ updateAtScroll: true }" allow-search v-model="row[index].fieldValue" :placeholder="$t('请输入')" class="system-form-item-value" :options="tools.isJSON(row[index]?.setting?.fieldExt) ? JSON.parse(row[index]?.setting?.fieldExt) : []" popup-container=".system-form-item" @change="returnCurrencyType"> </jw-select>
          </template>
          <!-- 退货时长 -->
          <template v-else-if="item.colKey == 'buyTime'">
            <jw-input-number :min="0" v-model="row[index].fieldValue" @input="(event) => getPrecisionNum(event, row[index])" :formatter="(event) => isShowThousandFormatter(event, row[index])" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(row[index], precisionNum)" @change="updateList($event, rowIndex, row[index])" :placeholder="$t('请输入')"> </jw-input-number>
          </template>
          <!-- 退货数量 -->
          <template v-else-if="item.colKey == 'purchaseNum'">
            <jw-input-number :min="1" v-model="row[index].fieldValue" @input="(event) => getPrecisionNum(event, row[index])" :formatter="(event) => isShowThousandFormatter(event, row[index])" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(row[index], precisionNum)" @change="updateList($event, rowIndex, row[index])" :placeholder="$t('请输入')"> </jw-input-number>
          </template>
          <!-- 退货开始日期 -->
          <template v-else-if="item.colKey == 'serviceStartDate'">
            <jw-date-picker v-model="row[index].fieldValue" :placeholder="$t('请输入')" class="system-form-item-value" :format="row[index]?.setting?.fieldExt" popup-container=".system-form-item" position="br" />
          </template>
          <!-- 退货结束日期 -->
          <template v-else-if="item.colKey == 'serviceEndDate'">
            <jw-date-picker v-model="row[index].fieldValue" :placeholder="$t('请输入')" class="system-form-item-value" :format="row[index]?.setting?.fieldExt" popup-container=".system-form-item" position="br" />
          </template>
          <!-- 是否开票 是否汇款 -->
          <template v-else-if="item.colKey == 'isInvoice'">
            <jw-select @change="callbackData(detailDataList)" :trigger-props="{ updateAtScroll: true }" allow-search v-model="row[index].fieldValue" :placeholder="$t('请输入')" class="system-form-item-value" :options="(tools.isJSON(row[index]?.setting?.fieldExt) && JSON.parse(row[index]?.setting?.fieldExt)) || []" popup-container=".system-form-item" allow-clear> </jw-select>
          </template>
          <template v-else-if="item.colKey == 'isPayment'">
            <jw-select @change="callbackData(detailDataList)" :trigger-props="{ updateAtScroll: true }" allow-search v-model="row[index].fieldValue" :placeholder="$t('请输入')" class="system-form-item-value" :options="(tools.isJSON(row[index]?.setting?.fieldExt) && JSON.parse(row[index]?.setting?.fieldExt)) || []" popup-container=".system-form-item" allow-clear> </jw-select>
          </template>
          <!-- 操作插槽 -->
          <template v-else-if="item.colKey == 'operation'">
            <template v-for="btn in buttons">
              <jw-link :key="btn.value" v-if="btn.value == `returnOrderProduct:delete`" @click="delReturnOrder(rowIndex)">{{ btn.label }}</jw-link>
            </template>
          </template>
          <template v-else>
            <template v-if="row[index]?.setting?.fieldType == 6">
              <xl-avatar
                v-if="row[index]?.fieldValue?.userId"
                :avatar="{
                  name: row[index]?.fieldValue?.userName || '',
                  url: row[index]?.fieldValue?.avatar,
                  id: row[index]?.fieldValue?.userId
                }"
                :size="22"
              />
              <template v-else>-</template>
            </template>
            <template v-else-if="row[index]?.setting?.fieldType == 12">
              {{ row[index]?.fieldValue?.label || row[index]?.customValue?.label || '-' }}
            </template>
            <template v-else>
              {{ row[index]?.fieldValue || '-' }}
            </template>
          </template>
          <span class="tips" v-if="detailDataList?.length && item.isRequired && (row[index].fieldValue == '' || row[index].fieldValue == null || row[index].fieldValue == undefined)">{{ data.fieldTypeList.indexOf(row[index]?.setting?.fieldType) != -1 ? `${$t('请输入')}${row[index]?.setting.fieldName}` : `${$t('请选择')}${row[index]?.setting.fieldName}` }}</span>
        </template>
      </fh-table>
      <add-order-detail ref="addOrderRef" @cb="getProductList"></add-order-detail>
    </template>
  </jw-space>
  <!-- 关联对象表格新增/编辑弹窗 -->
  <jw-modal titleAlign="start" :maskClosable="false" unmount-on-close :width="800" :visible="isAdd" :title="data.operation == 1 ? $t('新增') : $t('编辑')" @cancel="toggleAdd" class="add-table-modal">
    <jw-form :model="data.form" label-align="left" ref="formRef" @submit="handleSubmit">
      <jw-row :gutter="16">
        <template v-for="(item, index) in data.form.customForm" :key="item.id">
          <jw-col :span="item?.setting?.fieldType === 26 || item?.setting?.fieldType === 27 ? 24 : 12" :class="item?.setting?.fieldType === 27 ? 'sub-form-content' : ''">
            <jw-form-item asterisk-position="end" :field="`customForm.${index}.fieldValue`" :class="['system-form-item', item?.setting?.fieldType === 12 ? 'relevancy-input' : item.displayOneLine == 1 && item?.setting?.fieldType == 1 ? 'card-form-line' : '', item.displayOneLine == 2 ? 'one-third' : '', item.displayOneLine == 3 ? 'two-thirds' : '', item?.setting?.fieldType === 26 ? 'editor-form-item' : '']" :rules="item?.setting?.fieldKey === 'mobile' ? mobileRules : item?.setting?.fieldKey == 'buyTime' ? buyTimeRules(`customForm.${index}.fieldValue`, item?.setting.fieldName) : item.type == 20 ? rules(item) : ''" :validate-trigger="['blur', 'input', 'change']" :label-col-style="{ width: '120px' }" label-col-flex="auto" class="form-label-text">
              <template #label>
                <template v-if="item.type == 20">
                  <xl-label-text :value="item.label" :row="1" />
                  <jw-tooltip v-if="item?.setting?.fieldKey == 'buyTime'">
                    <icon-question-circle size="15" style="margin-left: 2px" />
                    <template #content>
                      <p>{{ $t('tips.buyTime1') }}</p>
                      <p>1、{{ $t('tips.buyTime2') }}</p>
                      <p>2、{{ $t('tips.buyTime3') }}</p>
                      <p>3、{{ $t('tips.buyTime4') }}</p>
                      <p>4、{{ $t('tips.buyTime5') }}</p>
                      <p>{{ $t('tips.buyTimeTitle') }}</p>
                      <p>1、{{ $t('tips.buyTime6') }}</p>
                      <p>2、{{ $t('tips.buyTime7') }}</p>
                    </template>
                  </jw-tooltip>
                </template>
              </template>
              <!-- 产品名称 -->
              <template v-if="item?.setting?.fieldKey === 'productId' || item?.setting?.fieldKey === 'product'">
                <xl-association :type="modulesItem?.type" :modules-item="item" :form-data="data.form.customForm" :placeholder="$t('请选择')" v-model="item.fieldValue" @change="(v, e) => productChange(index, v, e)" />
              </template>
              <!-- 产品类型 -->
              <template v-else-if="item?.setting?.fieldKey === 'productType'">
                {{ item?.fieldValue || '-' }}
              </template>
              <!-- 标准价格 -->
              <template v-else-if="item?.setting?.fieldKey === 'price' || item?.setting?.fieldKey === 'standardPrice'">
                <jw-input-number :min="1" :precision="item?.setting.fieldExt ? Number(item?.setting.fieldExt) : 2" v-model="item.fieldValue" allow-clear @change="updatePrice(item, $event)" hide-button :placeholder="$t('请选择')" :ref="`customForm.${index}.fieldValue`">
                  <template #suffix>
                    <icon-plus-circle size="18" class="plus-icon" @click="choosePrice" />
                  </template>
                </jw-input-number>
              </template>
              <!-- 购买时长 -->
              <template v-else-if="item?.setting?.fieldKey === 'buyTime'">
                <jw-input-number @change="buyTimeChange" :precision="JSON.parse(item?.setting.fieldExt)?.numberFormat ? Number(JSON.parse(item?.setting.fieldExt)?.numberFormat) : 2" :min="0.1" v-model="item.fieldValue" allow-clear :parser="(value) => `${value}`.replace(/\$\s?|(,*)/g, '')" :placeholder="$t('请输入')">
                  <template #append>{{ tools.isJSON(data.timeList) ? JSON.parse(data.timeList)?.find((item) => item.value == data.timeUnit)?.label : '' }} </template>
                </jw-input-number>
              </template>
              <!-- 停服日期 -->
              <template v-else-if="item?.setting?.fieldKey === 'serviceEndDate'">
                <jw-date-picker v-model="item.fieldValue" :disabledDate="(current) => dayjs(current).isBefore(dayjs(data.startDate))" :placeholder="$t('请选择')" @change="updateModulesItem('', item)" class="system-form-item-fields" :format="item?.setting?.fieldExt" position="br" />
              </template>
              <!-- 禾风特殊处理 -->
              <!-- 预算/分成对象 -->
              <template v-else-if="userInfo.orgId == hfOrgId && modulesItem?.businessData == 215">
                <!-- 拆账金额 -->
                <template v-if="item?.setting?.fieldType === 16 && item?.setting?.fieldKey == 'amount_a5sm3f'">
                  <jw-input-number @change="paymentChange" class="system-form-item-fields" v-model="item.fieldValue" :placeholder="$t('请输入')" :precision="Number(item?.setting?.fieldExt)" />
                </template>
                <!-- 拆账比例 -->
                <template v-else-if="item?.setting?.fieldType === 7 && (item?.setting?.fieldKey == 'number_K4ZA4t' || item?.setting?.fieldKey == 'number_DHDhnk')">
                  <jw-input-number v-if="JSON.parse(item?.setting?.fieldExt)?.numberFormat === '100'" :precision="3" v-model="item.fieldValue" class="system-form-item-fields" :placeholder="$t('请输入')" allow-clear hide-button disabled>
                    <template #append> % </template>
                  </jw-input-number>
                  <jw-input-number v-else-if="JSON.parse(item?.setting?.fieldExt)?.numberUnit" class="system-form-item-fields" v-model="item.fieldValue" :placeholder="$t('请输入')" :precision="Number(JSON.parse(item?.setting?.fieldExt)?.numberFormat)" disabled>
                    <template #append>
                      {{ JSON.parse(item?.setting?.fieldExt)?.numberUnit || '' }}
                    </template>
                  </jw-input-number>
                  <jw-input-number v-else class="system-form-item-fields" v-model="item.fieldValue" :placeholder="$t('请输入')" :precision="Number(JSON.parse(item?.setting?.fieldExt)?.numberFormat)" disabled />
                </template>
                <xl-update-fields v-else :modules="item" :formatData="data.form.customForm" @cb="updateModulesItem" :from="30" :errorDataMap="calcErrorMap" />
              </template>
              <!-- 履约义务对象 -->
              <template v-else-if="userInfo.orgId == hfOrgId && modulesItem?.businessData == 201 && item?.setting?.fieldKey == 'number_fix8ik'">
                <!-- 执行进度 -->
                <jw-input v-model="item.fieldValue" :placeholder="$t('请输入')" disabled class="system-form-item-fields" />
              </template>
              <template v-else>
                <template v-if="showFormTable">
                  <template v-if="item?.setting?.fieldKey === 'opportunityStage'">
                    <fh-update-fields :modules="stageModulesItem(item)" :formatData="data.form.customForm" :from="30" @cb="updateModulesItem" :errorDataMap="calcErrorMap" />
                  </template>
                  <!-- modules结构只有查找关联使用，其他不使用，尤其人员和部门，会把整个formatData反传重新覆盖掉当前表单数据 -->
                  <fh-update-fields v-else-if="item?.setting?.fieldType == 12 || item?.setting?.fieldType == 25" :modules="item" :formatData="[{ modules: data.form.customForm }]" :from="30" @cb="(getFormatData, moduleItem) => updateModulesItem(index, getFormatData, moduleItem)" :errorDataMap="calcErrorMap" />
                  <!-- 子表单 (35)-->
                  <template v-else-if="item.type == '35'">
                    <fh-form-subform :type="type" :copy="copy" :viewId="viewId" :entity="entity" :modulesItem="data.setEditSubForm == 0 ? item : modulesItem.modules?.find((el) => el.value == item.value)" :id="id" :from="30" :dataList="subFormModuleList?.[item.id]" :mainForm="data.form.customForm" @updateDataList="updateDataList" />
                  </template>
                  <fh-update-fields v-else :modules="item" :formatData="data.form.customForm" :from="30" @cb="(getFormatData, moduleItem) => updateModulesItem(index, getFormatData, moduleItem)" :errorDataMap="calcErrorMap" />
                </template>
              </template>
            </jw-form-item>
          </jw-col>
        </template>
      </jw-row>
    </jw-form>
    <template #footer>
      <jw-button size="small" @click="toggleAdd">{{ $t('取消') }}</jw-button>
      <jw-button type="primary" size="small" :loading="loading" @click="formRef.handleSubmit(1)" v-if="data.operation == 1 && showNextButton">
        {{ $t('确定并添加下一条') }}
      </jw-button>
      <jw-button type="primary" size="small" :loading="loading" @click="formRef.handleSubmit(2)">{{ $t('确定') }}</jw-button>
    </template>
  </jw-modal>
  <!-- 选择产品价格弹窗 -->
  <xl-price ref="priceRef"></xl-price>
  <!-- 新建编辑走布局 -->
  <fh-add-edit ref="addEditRef" @cbResult="addCbFun" />
  <!-- 打开详情 -->
  <ly-detail ref="detailRef" @cb="refreshList" :mask="true"></ly-detail>
  <!-- 编辑容器 -->
  <teleport :to="toTeleport" v-if="openEdit">
    <div class="overlay" :style="{ zIndex: contentStyle.zIndex - 1 }" @click.stop="hideEdit"></div>
    <div class="record-field-edit-content" :style="contentStyle">
      <field-detail-main :params="setRecrodEditParams" @close="hideEdit" :type="recordType" />
    </div>
  </teleport>
  <xl-association ref="associationRef" :formData="[]" :selectedItem="selectAssociateItem" :supplementData="bulkUseFormData" :modelValue="formTableStore?.tableAssociateIdData?.[modulesItem?.id] || []" :tableId="modulesItem?.id" @change="getBulkData" :isBulkSelect="true" type="20" :modulesItem="batchAssociateModule" :disabled="false" multiple />
</template>

<script setup lang="jsx">
import addOrderDetail from '@/views/sales-order/return-order/add-order-detail/add-order-detail.vue';
import { computed, h, nextTick, provide, reactive, ref, watch, onMounted, defineAsyncComponent } from 'vue';
import FhFormSubform from '../fh-form-subform/fh-form-subform.vue';
import FhUpdateFields from '../fh-update-fields/fh-update-fields.vue';
import { tools } from '@/utils/tools.js';
import { useI18n } from 'vue-i18n';
const FieldDetailMain = defineAsyncComponent(() => import('@/components/fh-set-fields/field-detail-main/index.vue'));
import useViewFields from '@/hooks/view-fields';
import { phoneRegexp } from '@/utils/const';
import { Message, Modal } from '@arco-design/web-vue';
import { publicService, layoutService, setService } from '@/api/';
import { useUserStore, useGrayscaleStore, useFormTableStore } from '@/store';
import { hfOrgId, objEntityMapping } from '@/utils/const';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import useLoading from '@/hooks/loading';
import useShowFields from '@/hooks/field-show';
import fieldPermission from '@/hooks/field-permission';
import useFhForm from '@/hooks/fh-form';
const { isRequiredField } = fieldPermission();
import FhFromTableTitle from '../fh-from-table-title/fh-from-table-title.vue';
import useButtonEvent from '@/hooks/button-event.js';
import QfBodySummaryCell from '@/components/table/qf-body-summary-cell/qf-body-summary-cell.vue';
import Big from 'big.js';
const { grayList } = useGrayscaleStore();
const { deleteObj } = useButtonEvent();
const { getfieldShowCom } = useShowFields(); //字段展示组件
const getComponent = (fieldType) => {
  return getfieldShowCom[fieldType] || getfieldShowCom[1];
};
import useEventListener from '@/hooks/event-listener';
const { eventListener } = useEventListener();
const { formatModuleFieldValue, getTableIdDiff, getSendData, isEmptyFieldValue } = useFhForm();
// 精度
import useThousandOption from '@/hooks/thousand';
import useFields from '@/hooks/fields';
// 处理精度 千分符
const { precisionNum, isShowThousandFormatter, getPrecisionNum, getPrecision } = useThousandOption();

const { fieldIconMapping } = useFields();
const { rules, setEditFormTable, getComputeing, setReferenceFieldValue, referenceFieldValue, getFieldLabel } = useViewFields();
const { loading, setLoading } = useLoading(false); //loading
const { userInfo } = useUserStore(); //用户信息
import useObjectForm from '@/hooks/object-form';
import { getAggregationList } from '@/components/table/utils';
import { aggregationTypes } from '@/components/table/contants';
const { setRecordLabel } = useObjectForm();
const { t } = useI18n();
const emit = defineEmits(['updateDataList']);
const formRef = ref();
const priceRef = ref(); //选择价格
const detailRef = ref(); //详情弹窗
const props = defineProps({
  modulesItem: {
    //表格的字段信息
    type: Object,
    default: () => {}
  },
  formData: {
    //表格数据
    type: Object,
    default: () => {}
  },
  //30:新增 40：编辑
  type: {
    type: Number,
    default: null
  },
  copy: {
    //1：复制
    type: Number,
    default: null
  },
  entity: {
    type: Number || String,
    default: null
  },
  viewId: {
    type: Number || String,
    default: null
  },
  id: {
    //这条主数据的ID(只有编辑时有)
    type: Number || String,
    default: ''
  },
  btns: {
    //按钮合集
    type: Array,
    default: () => []
  },
  findCountFieldsList: {
    // 计算字段合集
    type: Array,
    default: () => []
  },
  detailDataList: {
    type: Array,
    default: () => []
  }
});

// 表格类型
const TABLE_TYPE = {
  RECORD: 'record', // record 查询记录
  ASS_RECORD: 'assRecord' // 关联记录
};

// 汇总类型数据缓存 前端一次性存储
const aggregationTypeCache = reactive({});

// 表格类型
const recordType = ref(''); // record 查询记录 assRecord 关联记录

// 获取默认汇总类型
const getDefaultAggregationType = (col) => {
  const aggTypeList = getAggregationList(col.fieldType, col.fieldExt);
  return aggTypeList?.find((x) => x.default)?.value;
};

// 获取汇总类型
const getAggregationType = (col) => {
  return aggregationTypeCache[col.colKey] || getDefaultAggregationType(col);
};

// 汇总类型改变
const aggregationChange = (data) => {
  aggregationTypeCache[data.fieldKey] = data.type;
};

// 汇总值格式化
const aggregationValueFormatter = tools.formatSummary.bind(tools);

// 获取汇总值
const getAggregationValue = (col) => {
  const type = getAggregationType(col);
  if (!type) return null;
  // 将当前列所有值转换为Big.js对象
  const data = (
    props.detailDataList?.map((item) => {
      const module = item.find((d) => d.value === col.colKey);
      if (!module) return null;
      const value = processRecordData(module, col.fieldType, col.fieldExt);
      if (!tools.isNumberLike(value)) return null;
      return new Big(value);
    }) || []
  ).filter(Boolean);
  switch (type) {
    // 汇总类型：求和 累加
    case aggregationTypes.sum.value: {
      return +data.reduce((pre, curr) => {
        return pre.add(new Big(curr));
      }, new Big(0));
    }
  }
};

/*********** 批量新增 start ***********/
const getTableData = () => {
  return cloneDeep(props.detailDataList || []);
};
const isAllowBatchAdd = computed(() => {
  return props.modulesItem?.tableOperation?.batchTableAdd == 1 && props.modulesItem?.type == 30 && hasPermission(`${props.modulesItem?.businessData >= 200 ? props.modulesItem?.businessData : objEntityMapping?.[props.modulesItem?.businessData]}` + ':add');
});
const bulkUsedFieldKey = ref([]);
//获取所有的已选中的查找关联集合
const selectAssociateItem = computed(() => {
  const _items = [];
  props.detailDataList?.forEach((td) => {
    const _associate = td?.find((tdf) => tdf?.setting?.fieldKey == batchAssociateModule.value?.setting?.fieldKey);
    if (_associate?.fieldValue) {
      _items.push({
        id: _associate?.fieldValue,
        label: _associate?.fieldValueName || _associate?.customValue?.label || _associate?.fieldValue,
        value: _associate?.fieldValue
      });
    }
  });

  return _items;
});
const bulkUseFormData = computed(() => {
  //如果不存在批量添加则不处理
  if (props.modulesItem?.tableOperation?.batchTableAdd === '1') {
    const formData = getSendData(props.formData);
    const retField = {};
    bulkUsedFieldKey.value.forEach((bufk) => {
      if (formData?.[bufk] !== undefined) {
        retField[bufk] = formData[bufk];
      }
    });

    return retField;
  }
  return {};
});
const itemFormData = ref({}); //为落库时当前行数据
const batchAssociateModule = computed(() => {
  if (props.modulesItem?.tableOperation?.batchTableAdd === '1') {
    return props.modulesItem?.modules?.find((mi) => mi?.setting?.fieldKey == props.modulesItem?.tableOperation?.batchTableKey) || {};
  }
  return {};
});
provide('bulkAddParams', {
  supplementData: bulkUseFormData,
  fieldKey: props.modulesItem?.tableOperation?.batchTableKey || '',
  tableId: props.modulesItem?.id,
  itemFormData: itemFormData
});
const formTableStore = useFormTableStore();
const associationRef = ref();
const openListModal = () => {
  associationRef.value?.openDialog?.();
};
const batchAssign = async (add, fieldIndex = null, list = null, _dataList = null, rowIndex = null) => {
  try {
    const param = {
      eventType: 0,
      layoutConfigId: batchAssociateModule.value?.id,
      fieldKey: batchAssociateModule.value?.setting?.fieldKey,
      entity: props.modulesItem?.businessData,
      associateEntity: batchAssociateModule.value?.setting?.fieldExt,
      associateId: '',
      data: {},
      fieldKeyReferenceList: [],
      modules: props.modulesItem?.modules
        ?.filter((mm) => mm?.setting?.fieldType == 12)
        ?.map((mm) => {
          return {
            fieldKey: mm?.setting?.fieldKey,
            id: mm?.id
          };
        }),
      settingId: batchAssociateModule.value?.setting?.id
    };
    const params = [];
    add?.forEach((id) => {
      params.push({
        ...param,
        associateId: id
      });
    });
    const batchFieldSetting = batchAssociateModule.value?.setting;
    const res = await publicService.getAssociationAssign4Bulk(params);
    if (!res?.error) {
      add?.forEach((id) => {
        const _modules = cloneDeep(props.modulesItem?.modules || []);
        _modules?.forEach((module) => {
          if (module?.setting?.fieldType == 27 && module?.modules?.length) {
            module.modules = [module.modules]; // 子表单需要包装一层数组
          }
        });
        if (rowIndex === null) {
          if (fieldIndex?.[batchFieldSetting?.fieldKey] !== undefined) {
            const fieldItem = list?.find((v) => v?.id == id);
            _modules[fieldIndex[batchFieldSetting?.fieldKey]] = formatModuleFieldValue(_modules[fieldIndex[batchFieldSetting?.fieldKey]], fieldItem);
          }
          const assignKeys = Object.keys(res?.result?.[id]);
          if (assignKeys?.length) {
            assignKeys?.forEach((ak) => {
              if (fieldIndex?.[ak] !== undefined) {
                _modules[fieldIndex[ak]] = formatModuleFieldValue(_modules[fieldIndex[ak]], res?.result?.[id]?.[ak]);
              }
            });
          }

          console.log('批量获取数据33', _modules);

          _dataList.push(_modules);
        } else {
          //快捷编辑
          const _fieldIndex = []; //快捷编辑没有数组集合，这里重新获取组装
          props.modulesItem?.modules?.forEach((mm, index) => {
            _fieldIndex[mm?.setting?.fieldKey] = index;
          });
          const assignKeys = Object.keys(res?.result?.[id]);

          if (assignKeys?.length) {
            const _tableData = getTableData();

            assignKeys?.forEach((ak) => {
              if (_fieldIndex?.[ak] !== undefined) {
                _tableData[rowIndex][_fieldIndex[ak]] = formatModuleFieldValue(_modules[_fieldIndex[ak]], res?.result?.[id]?.[ak]);
              }
            });

            callbackData(_tableData);
          }
        }
      });
    }
  } catch (e) {
    console.log(e);
  }
};
const getBulkData = async ({ list, ids }) => {
  const _dataList = getTableData();
  const { add, del } = getTableIdDiff(ids || [], formTableStore?.tableAssociateIdData?.[props.modulesItem?.id] || []);
  const fieldIndex = [];
  props.modulesItem?.modules?.forEach((mm, index) => {
    fieldIndex[mm?.setting?.fieldKey] = index;
  });
  const permissionIndex = [];
  if (del?.length) {
    _dataList?.forEach((dl, i) => {
      const batchFieldSetting = batchAssociateModule.value?.setting;
      if (del?.includes(dl[fieldIndex[batchFieldSetting?.fieldKey]]?.fieldValue)) {
        //清空查找关联字段值
        dl[fieldIndex[batchFieldSetting?.fieldKey]] = cloneDeep(props.modulesItem?.modules)?.[fieldIndex[batchFieldSetting?.fieldKey]];
        permissionIndex.push(i);
      }
    });
  }
  if (add?.length) {
    const oldLength = _dataList?.length;
    await batchAssign(add, fieldIndex, list, _dataList);
    const newLength = _dataList?.length;
    //将新增索引添加到需要调用业务规则的数组中
    if (newLength > oldLength) {
      for (let i = oldLength; i < newLength; i++) {
        permissionIndex.push(i);
      }
    }
  }
  callbackData(_dataList);
  formTableStore.setTableRequiredErrorData([]);
  await getBatchPermission(permissionIndex, _dataList);
  //批量操作后根据表格数据重新初始化id信息
  initFormAssociateIds();
  associationRef.value?.closeModal?.();
};
/*********** 批量新增 end ***********/
const showFormTable = ref(true);
const buttons = computed(() => props.btns); //动态读取每次规则匹配后的权限
const calcErrorMap = ref(); // 计算字段错误集合
const data = reactive({
  customerId: '',
  //关联表单
  form: {
    customForm: [props.modulesItem.modules]
  },
  //商机产品
  productId: '',
  currencyType: '',
  operation: 1,
  setEditSubForm: 0, //0:新增，1：编辑
  //合同产品
  tableloading: false,
  priceSheetId: '',
  contractId: '',
  //退货产品
  productList: [],

  recordIndex: '',
  fieldTypeList: [0, 1, 7, 11, 13, 16, 21, 23, 26],
  signData: '', //签单额
  timeList: [], //时长单位的下拉数据
  startDate: '', //开服日期
  isRequesting: true, //计算字段是否计算完
  isSubmitFlag: 0, //是否点击确定
  id: null,
  recordEntity: null,
  // 特殊entity 不校验用户权限
  specialEntityList: ['7', '9', '11', '12', '14', '32']
});

const isShowAddBtn = (btn) => {
  // 特殊entity 不校验用户权限
  const _modulesItem = props.modulesItem;
  let hasAdd;
  if (data.specialEntityList.includes(_modulesItem?.businessData)) {
    hasAdd = _modulesItem?.type == 30 || (_modulesItem?.type == 31 && hasPermission(btn.value));
  } else {
    hasAdd = (_modulesItem?.type == 30 && hasPermission(btn.value)) || (_modulesItem?.type == 31 && hasPermission(btn.value));
  }
  return btn.value == `${_modulesItem?.businessData >= 200 ? _modulesItem?.businessData : objEntityMapping?.[_modulesItem?.businessData]}` + ':add' && btn.value != `returnOrderProduct:add` && hasAdd;
};

// 所有数据（基本信息+关联表格）
const initCustomerId = () => {
  props.formData.map((item) => {
    if (item?.modules) {
      item?.modules.forEach((list) => {
        if (list.type == 20) {
          if (list?.setting.fieldKey == 'customerId') {
            data.customerId = list.fieldValue?.value || list.fieldValue;
          } else if (list?.setting.fieldKey == 'priceSheetId') {
            data.priceSheetId = list.fieldValue;
          } else if (list?.setting.fieldKey == 'contractId') {
            data.contractId = list.fieldValue;
          }
        }
      });
    }
  });
};
//获取按钮权限
const hasPermission = (val) => {
  return userInfo?.roles?.indexOf(val) != -1;
};
// 获取编辑权限
const getEditPermission = (record) => {
  return props.modulesItem?.businessData == 101 || (!record?.lockedOrigin && props.modulesItem?.businessData != 101);
};
// 组件按钮值
const getBtnValue = (buttonType) => {
  const entity = props.modulesItem?.businessData >= 200 ? props.modulesItem?.businessData : objEntityMapping?.[props.modulesItem?.businessData];
  return entity + `:${buttonType}`;
};

// 筛选出所有符合显示条件的按钮
const filteredButtons = (record) => {
  if (!buttons.value?.length) return []; // 按钮列表为空时直接返回空数组
  const getBtnList = cloneDeep(buttons.value);

  return getBtnList?.filter((btn) => {
    const btnValue = btn.value;
    const type = props.modulesItem?.type;
    const entity = props.modulesItem?.businessData;
    // 编辑按钮的显示条件
    if (btnValue == getBtnValue('edit')) {
      const hasEdit = type == 31 && hasPermission(btnValue) && getEditPermission(record) && findComputedInfo(record)?.status != 1;
      if (data.specialEntityList.includes(entity)) {
        return type == 30 || hasEdit;
      } else {
        return (type == 30 && hasPermission(btnValue)) || hasEdit;
      }
    }

    // 删除按钮的显示条件
    if (btnValue == getBtnValue('delete')) {
      const hasDelete = type == 31 && hasPermission(btnValue) && findComputedInfo(record)?.status != 1;
      if (data.specialEntityList.includes(entity)) {
        return type == 30 || hasDelete;
      } else {
        return (type == 30 && hasPermission(btnValue)) || hasDelete;
      }
    }

    // 复制按钮的显示条件
    if (btnValue == getBtnValue('copy')) {
      const hasCopy = type == 31 && hasPermission(btnValue);
      if (data.specialEntityList.includes(entity)) {
        return type == 30 || hasCopy;
      } else {
        return (type == 30 && hasPermission(btnValue)) || hasCopy;
      }
    }

    // 其他按钮默认不显示（如果有扩展需求可在此添加）
    return false;
  });
};

watch(
  () => props.formData,
  () => {
    initCustomerId();
  },
  { deep: true }
);
const setRecordData = (fieldType, fieldExt, fieldValue) => {
  const setTableObj = {
    fieldValue: fieldValue,
    list: null
  };
  const getJsonFieldExt = fieldExt && tools.isJSON(fieldExt) ? JSON.parse(fieldExt) : {};
  if (fieldType == 23) {
    setTableObj.fieldValue = !isNaN(parseFloat(fieldValue)) ? tools.getPercentage(fieldValue, getJsonFieldExt?.numberFormat || 2) : '';
  }
  if (fieldType == 16) {
    setTableObj.fieldValue = tools.getPrice(fieldValue, getJsonFieldExt || 2);
  }

  if (fieldType == 6) {
    //6.人员
    const _user = [];

    const _list = fieldValue ? (Array.isArray(fieldValue) ? fieldValue : [fieldValue]) : [];
    _list.forEach((v) => {
      _user.push({
        id: v.userId || v.id || '',
        userId: v.userId || v.id || '',
        userName: v.userName,
        avatarOrigin: v.avatar || v.avatarOrigin || ''
      });
    });
    setTableObj.list = {
      userList: _user,
      departList: []
    };
  }
  if (fieldType == 22) {
    //22.部门
    const _depart = [];

    const _list = fieldValue ? (Array.isArray(fieldValue) ? fieldValue : [fieldValue]) : [];
    _list.forEach((v) => {
      _depart.push({
        id: v.departmentId || v.id || '',
        departmentName: v.departmentName || v.name || ''
      });
    });
    setTableObj.list = {
      departList: _depart,
      userList: []
    };
  }

  return setTableObj;
};

const recordRefresh = async (params) => {
  // 常量抽离，避免魔法值
  const SPECIAL_TYPES_CUSTOM_VALUE = [12, 25];
  const SPECIAL_TYPES_FV = [6, 22];
  let findRecord = null;
  let findModules = null;

  hideEdit();

  // 解构参数，简化访问
  const { businessId, fieldKey, fieldValue, isSubForm, recordId, apiValue } = params;
  const detailDataList = getTableData();

  console.log('回传参数333', params);

  if (fieldKey == batchAssociateModule.value.setting?.fieldKey && props.modulesItem?.tableOperation?.checkTableData == '0' && isAssociateRepeat(fieldValue?.value, currentRow.value)) {
    // 是否是批量查找关联字段 且 开启查重 且 查重通过
    Message.warning(t('此项内容已存在，不允许重复创建'));
    return false;
  }

  // 提取字段更新的核心逻辑（主表单和子表单通用）
  const updateField = async (fieldItem) => {
    // 字段配置不存在或字段键不匹配时直接返回
    console.log('匹配字段33', fieldItem);
    if (!fieldItem?.setting || fieldItem.setting.fieldKey != fieldKey) {
      return;
    }

    // 处理字段值转换
    const showFieldValue = setRecordData(fieldItem.setting.fieldType, fieldItem.setting.fieldExt, fieldValue);
    fieldItem.fieldValue = showFieldValue.fieldValue;

    // 处理特殊类型12/25：设置customValue
    if (SPECIAL_TYPES_CUSTOM_VALUE.includes(fieldItem.setting.fieldType)) {
      fieldItem['customValue'] = fieldValue;

      if (recordType.value === TABLE_TYPE.ASS_RECORD) {
        fieldItem.fieldValue = fieldItem.setting.fieldType == 12 ? showFieldValue.fieldValue?.value || null : showFieldValue.fieldValue.map((m) => m.value);
      }

      if (fieldItem.setting.fieldKey === batchAssociateModule.value?.setting?.fieldKey) {
        // 改的是批量查找关联字段 批量更新id集合
        const _ids = cloneDeep(formTableStore.tableAssociateIdData?.[props.modulesItem?.id] || []);
        _ids[currentRow.value] = fieldValue?.value;
        formTableStore.setTableAssociateIdData(props.modulesItem?.id, _ids);
        //

        if (fieldValue?.value) {
          await batchAssign([fieldValue?.value], null, null, getTableData(), currentRow.value);
        }
      }
    }

    // 关联记录中 这些参数类型需要特殊处理
    if (recordType.value === TABLE_TYPE.ASS_RECORD && [2, 3, 4, 5, 10, 8, 9].includes(fieldItem.setting.fieldType)) {
      fieldItem.fieldValue = formatModuleFieldValue(fieldItem, apiValue).fieldValue;
    }

    // 处理特殊类型6/22：设置setting.fv
    if (SPECIAL_TYPES_FV.includes(fieldItem.setting.fieldType)) {
      fieldItem.setting['fv'] = showFieldValue.list;
    }

    findModules = fieldItem;
  };

  // 处理主表单逻辑
  const processMainForm = (list) => {
    if (recordType.value == TABLE_TYPE.ASS_RECORD) {
      // 关联记录
      list.forEach((row, rIndex) => {
        if (rIndex === currentRow.value) {
          // 编辑的当前行
          findRecord = row;
          row.forEach(updateField); // 批量更新行内字段
        }
      });
    } else {
      // 查询记录
      list.forEach((row) => {
        // 找到匹配businessId的行
        if (row[0]?.detailId == businessId) {
          findRecord = row;
          row.forEach(updateField); // 批量更新行内字段
        }
      });
    }
  };

  // 处理子表单逻辑（type=35）
  const processSubForm = (list) => {
    if (recordType.value == TABLE_TYPE.ASS_RECORD) {
      // 关联记录
      list.forEach((row, rowIndex) => {
        if (rowIndex === currentRow.value) {
          row.forEach((subRow, subRowIndex) => {
            if (subRow.type == 35 && subRow.modules?.length) {
              console.log(subRowIndex);
              subRow.modules.forEach((sd, sdIndex) => {
                if (sdIndex === currentSubRow.value) {
                  findRecord = sd;
                  sd.forEach(updateField); // 批量更新模块内字段
                }
              });
            }
          });
        }
      });
    } else {
      // 查询记录
      list.forEach((row) => {
        if (row[0]?.detailId == recordId) {
          //主数据id
          // 非子表单类型或无modules时直接跳过
          row.forEach((item) => {
            if (item?.type == 35 && item.modules?.length) {
              item.modules?.forEach((module) => {
                // 找到匹配businessId的模块
                if (module[0]?.detailId == businessId) {
                  //子表单id
                  findRecord = module;
                  module.forEach(updateField); // 批量更新模块内字段
                }
              });
            }
          });
        }
      });
    }
  };

  // 执行核心处理

  if (isSubForm) {
    processSubForm(detailDataList);
  } else {
    processMainForm(detailDataList);
  }

  console.log('表格数据333', detailDataList);

  if (findRecord && findModules) {
    const sendFormData = getSendData([{ modules: findRecord }], true);
    const permissions = await getPermission(businessId, sendFormData);
    findRecord?.forEach(async (item) => {
      item['PERMISSION'] = permissions;
    }); // 批量更新行内字段
  }

  await getComputedInfo(false, [businessId]);

  callbackData(detailDataList);
};
// 获取计算错误数据
const getComputedErrorLog = async (businessIdList, entity) => {
  try {
    const json = await setService.getComputedErrorLog({
      entity: entity,
      businessIdList: businessIdList,

      apiIndex: `${entity}-${Math.random()}`
    });
    if (!json.error) {
      const result = json.result;
      return result;
    }
  } catch (error) {
    console.log(error);
  }
};
// 获取计算标识
const computedErrorInfo = ref(null);
const getComputedInfo = async (init = false, ids = []) => {
  if (props.modulesItem?.type == 31) {
    const businessIdList = init ? props.detailDataList?.map((dItem) => dItem?.[0].detailId) : ids;

    const computedInfo = businessIdList?.length ? await getComputedErrorLog(businessIdList, props.modulesItem.businessData) : {};
    computedErrorInfo.value = computedInfo;
  }
};
// 批量获取业务规则
const getBatchPermission = async (indexList, _dataList) => {
  if (!indexList?.length) return;
  // const _dataList = getTableData();
  console.log(_dataList, 'console.log(_dataList');
  const valueParams = _dataList
    ?.filter((v, index) => indexList.includes(index))
    ?.map((dl) => {
      return getSendData([{ modules: dl }], true);
    });
  const res = await layoutService.permissionBatch({
    type: 'DATA',
    value: valueParams,
    entity: props.modulesItem.businessData,
    source: 1
  });
  if (!res?.error) {
    const permissions = res?.result?.permissions || {};
    indexList.forEach((i, permissionIndex) => {
      _dataList?.[i]?.forEach((dli) => {
        dli['PERMISSION'] = permissions?.[permissionIndex] || {};
      });
    });
    callbackData(_dataList);
  }
};

//获取权限
const getPermission = async (businessId, sendFormData = undefined) => {
  try {
    const res = await layoutService.fieldPermission({
      type: recordType.value == TABLE_TYPE.ASS_RECORD ? 'DATA' : 'ID',
      value: recordType.value == TABLE_TYPE.ASS_RECORD ? sendFormData : businessId,
      entity: props.modulesItem.businessData,
      source: recordType.value == TABLE_TYPE.ASS_RECORD ? 1 : 4 // 1 新建 4 详情
    });
    if (!res?.error) {
      const permissions = res?.result?.permissions || {};
      return permissions;
    }
  } catch (e) {
    console.log(e);
  }
};
provide('globalParams', {
  id: computed(() => data.id),
  entity: computed(() => data.recordEntity),
  viewId: '',
  customerId: computed(() => data.customerId), //退货单中的选择订单使用
  type: computed(() => props.type),
  recordRefresh: recordRefresh
});
// 打开详情页面
const specialProduct = [7, 9, 11, 14, 32]; //特殊产品对象
const openDetails = (record) => {
  //主属性跳转
  // 获取对象entity
  console.log('详情跳转', record);

  if (specialProduct.includes(Number(props.entity))) {
    //特殊产品显示不能点击状态
    return false;
  }
  if (!record?.detailId) {
    //如果没有detailId 不能点击，代表是新增数据，还未入库
    return false;
  }
  data.recordEntity = record.recordEntity;
  data.id = record.detailId;
  detailRef.value.openDialog();
};
provide('mainTableMethods', {
  // 主表格方法
  toDetails: openDetails
});
const validateFormItems = () => {
  const inputList = [0, 1, 7, 11, 13, 16, 23, 26]; // 请输入的字段
  // 遍历表单数据
  const getFormData = data.form.customForm;
  for (const module of getFormData || []) {
    // 必填校验
    //富文本必填校验
    if (module?.type == 20 && module?.setting?.fieldType == 26 && module.isRequired == 1 && (module?.fieldValue == '<p><br></p>' || module?.fieldValue == '')) {
      Message.warning(t('请输入') + module?.setting?.fieldName);
      return {
        hasEmptyRequiredTable: true,
        hasOverTable: false,
        hasSubFormEmptyError: false,
        hasLinkError: false
      };
    }

    if (module?.type == 35) {
      //子表单
      const data = subFormModuleList.value?.[module.id];

      // 必填校验
      if (module.isRequired && (!data || data.length === 0)) {
        const requiredErrorMessage = module?.label ? `请至少添加一条【${module?.label}】数据！` : '请至少添加一条子表单数据';
        Message.warning(requiredErrorMessage);
        return {
          hasEmptyRequiredTable: true,
          hasOverTable: false,
          hasSubFormEmptyError: false,
          hasLinkError: false
        };
      }

      // 数量限制校验
      if (module.type == 35 && data && data.length > 300) {
        Message.warning('子表单数据最多添加300行！');
        return {
          hasEmptyRequiredTable: false,
          hasOverTable: true,
          hasSubFormEmptyError: false,
          hasLinkError: false
        };
      }

      // 校验子表单超链接格式(二维数组)
      for (const list of data || []) {
        for (const item of list || []) {
          if (item?.setting?.isRequired && (item.fieldValue === '' || item.fieldValue === null || item.fieldValue === undefined || (Array.isArray(item.fieldValue) && item.fieldValue?.length === 0))) {
            const waringMsg = inputList.includes(item?.setting?.fieldType) ? '请输入' + item?.setting?.fieldName : '请选择' + item?.setting?.fieldName;
            Message.warning(waringMsg);
            return {
              hasEmptyRequiredTable: false,
              hasOverTable: false,
              hasSubFormEmptyError: true,
              hasLinkError: false
            };
          }

          if (item?.setting?.fieldType === 11 && item?.fieldValue && !tools.checkLink(item.fieldValue)) {
            const linkErrorMessage = '格式不正确，请以http:// 或 https:// 开头，且不能包含汉字!';
            Message.warning(linkErrorMessage);
            return {
              hasEmptyRequiredTable: false,
              hasOverTable: false,
              hasSubFormEmptyError: false,
              hasLinkError: true
            };
          }
        }
      }
    }
  }

  // 如果所有检查都通过，返回没有错误的结果
  return {
    hasEmptyRequiredTable: false,
    hasOverTable: false,
    hasSubFormEmptyError: false,
    hasLinkError: false
  };
};

const updateDataList = (cbData) => {
  subFormModuleList.value[cbData?.id] = cbData.data;
};

const isAssociateRepeat = (associateFieldValue, recordIndex) => {
  return !isEmptyFieldValue(associateFieldValue) && formTableStore.tableAssociateIdData?.[props.modulesItem?.id]?.findIndex((id, index) => id == associateFieldValue && (recordIndex === '' || recordIndex != index)) > -1;
};

const handleSubmit = async ({ values, errors }, ref) => {
  console.log('values-------', values);
  if (!errors) {
    const tableOperation = props.modulesItem?.tableOperation || {};
    if (tableOperation?.batchTableAdd === '1' && tableOperation?.checkTableData === '0') {
      const associateFieldValue = values?.customForm?.find((v) => v?.setting?.fieldKey == batchAssociateModule.value?.setting?.fieldKey)?.fieldValue;
      if (associateFieldValue && isAssociateRepeat(associateFieldValue, data.recordIndex)) {
        //支持批量并且判断查重时校验查找关联id信息
        Message.warning(t('此项内容已存在，不允许重复创建'));
        return false;
      }
    }
    //文件未上传完给提示
    const incompleteFileList = [];
    data.form.customForm?.forEach((item) => {
      if (item.type == 20 && item?.setting?.fieldType === 18) {
        if (item.fieldValue && item.filesList && item.fieldValue.length != item.filesList.length) {
          incompleteFileList.push(item.fieldValue);
        }
      }
    });

    if (incompleteFileList && incompleteFileList.length) {
      Message.warning(t('文件未上传完成,请稍后提交！'));
      return;
    }
    // 调用验证函数
    const validationResult = validateFormItems();
    if (validationResult.hasEmptyRequiredTable || validationResult.hasOverTable || validationResult.hasSubFormEmptyError || validationResult.hasLinkError) {
      // 如果校验未通过，则不再继续后续操作
      return false;
    }
    if (!data.isRequesting) {
      // Message.warning('数据计算中');
      data.isSubmitFlag = ref;
      setLoading(true);
      return false;
    }
    data.isRequesting = true;
    data.isSubmitFlag = 0;

    getDetailList(cloneDeep(data.form.customForm));
    if (ref == 1) {
      //确定并添加下一条
      showFormTable.value = false;
      //清空使用表单的清空，不在使用赋值为''的逻辑，不然会引发特殊字段异常【本次调整原因：用户点击确定并继续添加后，下拉选择的数组值中有一个默认''清不掉】
      data.form.customForm.forEach((v) => {
        if ((v?.setting?.fieldType === 6 && v?.setting?.fieldKey != 'chargePerson') || v?.setting?.fieldType === 22) {
          v.setting['fv'] = [];
        }
        if (v?.setting?.fieldType === 18) {
          v.filesList = [];
          v.fieldValue = [];
        }
      });
      subFormModuleList.value = {};
      formRef.value?.resetFields();
      nextTick(() => {
        showFormTable.value = true;
      });
    } else {
      toggleAdd();
    }
  }
};
// 判断是否显示内容---为null和undefined、空数组、空对象、空字符串不显示，但等于0或fieldType==24时显示
const isShowContent = (fieldType, fieldValue) => {
  if (fieldType === 24) return true;
  // null和undefined排除
  if (fieldValue == null) return false;
  if (fieldValue === 0) return true;
  if (typeof fieldValue === 'string') return fieldValue?.length;
  if (Array.isArray(fieldValue)) return fieldValue?.length;
  if (typeof fieldValue === 'object') return Object.keys(fieldValue)?.length;
  return true;
};
const uniqueByValue = (arr) => {
  const seen = new Set(); // 用于记录已出现过的 value
  return arr.filter((item) => {
    // 如果 value 未出现过，则添加到 Set 并保留该元素
    if (!seen.has(item.value)) {
      seen.add(item.value);
      return true;
    }
    // 已出现过则过滤掉
    return false;
  });
};
// 处理表格数据
const processRecordData = (_module, fieldType, fieldExt) => {
  const params = {
    fieldValue: _module?.fieldValue
  };
  if ([2, 3, 4, 5, 10].includes(fieldType)) {
    if ([3, 5, 10].includes(fieldType) && Array.isArray(_module?.fieldValue)) {
      const symbol = [3, 5].includes(fieldType) ? ',' : '/';
      params.fieldValue = _module?.fieldValue.join(symbol);
    }
    const getLabel = getFieldLabel(params.fieldValue, fieldExt, fieldType, ',');

    params.fieldValue = getLabel !== '-' ? getLabel : null;
  }
  if (fieldType == 6) {
    //人员6
    if (_module?.setting?.fv?.userList?.length) {
      params.fieldValue = _module?.setting?.fv?.userList;
    }
  }
  if (fieldType == 9) {
    //日期范围
    if (Array.isArray(_module?.fieldValue) && _module?.fieldValue?.[0] && _module?.fieldValue?.[1]) {
      params.fieldValue = JSON.stringify({ beginDate: _module?.fieldValue[0], endDate: _module?.fieldValue[1] });
    } else if (tools.isJSON(_module?.fieldValue) && JSON.parse(_module?.fieldValue)?.beginDate && JSON.parse(_module?.fieldValue)?.endDate) {
      params.fieldValue = _module.fieldValue;
    } else {
      params.fieldValue = null;
    }
  }
  if (fieldType == 12) {
    //查找关联单选
    if (_module?.customValue?.label && _module?.customValue?.value) {
      params.fieldValue = { ..._module?.customValue, business: fieldExt };
    } else if (_module?.fieldValueName && _module?.fieldValue) {
      params.fieldValue = { label: _module?.fieldValueName, value: _module?.fieldValue, business: fieldExt };
    }
  }

  if (fieldType == 16) {
    //16.金额
    params.fieldValue = tools.setPrice(_module.fieldValue, fieldExt || 2);
  }
  if (fieldType == 18) {
    //附件
    if (_module?.fieldValue && Array.isArray(_module?.fieldValue)) {
      params.fieldValue = JSON.stringify(_module?.fieldValue);
    }
  }

  if (fieldType == 22) {
    //部门
    if (_module?.setting?.fv?.departList?.length) {
      params.fieldValue = _module?.setting?.fv?.departList;
    }
  }
  if (fieldType == 23) {
    //23.百分比
    const numberFormat = fieldExt && tools.isJSON(fieldExt) ? JSON.parse(fieldExt)?.numberFormat || 2 : 2;
    params.fieldValue = !isNaN(parseFloat(_module?.fieldValue)) ? tools.setPercentage(_module?.fieldValue, numberFormat) : '';
  }
  if (fieldType == 24) {
    //计算类型
    if (fieldExt && tools.isJSON(fieldExt)) {
      const jsonExt = JSON.parse(fieldExt);
      if (jsonExt?.type == 6 || jsonExt?.type == 16) {
        //6：汇总金额 16：金额
        params.fieldValue = !isNaN(parseFloat(_module?.fieldValue)) ? tools.setPrice(_module?.fieldValue, jsonExt?.dataType) : '';
      } else if (jsonExt?.type == 23) {
        //百分比
        params.fieldValue = !isNaN(parseFloat(_module?.fieldValue)) ? tools.setPercentage(_module?.fieldValue, jsonExt?.dataType) : '';
      }
    }
  }
  if (fieldType == 25) {
    //查找关联多选

    if (_module?.customValue?.length) {
      params.fieldValue = uniqueByValue(_module?.customValue.map((v) => ({ ...v, business: fieldExt })));
    } else if (_module?.fieldValueName?.length && _module?.fieldValue?.length) {
      params.fieldValue = _module?.fieldValueName?.map((v, i) => ({ label: v, value: _module?.fieldValue[i], business: fieldExt }));
    }
  }
  return params.fieldValue;
};
const getSetting = (_module) => {
  let fieldType = _module?.setting?.fieldType;
  let fieldExt = _module?.setting?.fieldExt;

  const isQuoteField = _module?.setting?.fieldType == 21; // 引用字段
  if (isQuoteField) {
    fieldType = _module?.setting?.business?.fieldType;
    fieldExt = _module?.setting?.business?.fieldExt;
  }

  return {
    isQuoteField,

    fieldType,
    fieldExt
  };
};
//获取计算状态
const findComputedInfo = (record) => {
  return computedErrorInfo.value?.find((info) => info.businessId == record?.detailId);
};
// 创建列配置
const createColumnConfig = (record, item, isSubForm = false, subEntityId = null) => {
  //如果是空数据显示行的话 直接设置透明度0的tr
  if (!Object.keys(record)?.length) return h('div', { style: 'opacity: 0;' }, '-');
  const _module = record?.find((r) => r?.setting?.fieldKey == item?.setting?.fieldKey);

  const { fieldType, fieldExt, isQuoteField } = getSetting(_module);

  if (!isShowContent(fieldType, _module?.fieldValue)) return emptyTextNode();
  const matchingItem = findComputedInfo(_module);

  const params = {
    col: { ..._module },
    row: { ..._module, recordEntity: props.modulesItem.businessData, computedInfo: matchingItem },
    fieldKey: _module?.setting?.fieldKey,
    mainField: _module?.setting?.mainField,
    isRequired: _module?.setting?.isRequired,
    fieldValue: _module?.fieldValue ?? null,
    fieldType: fieldType,
    fieldExt: fieldExt,
    fieldName: _module?.setting?.fieldName,
    sourceType: 1,
    tableLevel: 1,
    isSubForm: isSubForm,
    isAutoHeight: true,
    entity: props.modulesItem.businessData,
    subEntityId: subEntityId,
    permissions: 1,
    mask: true //显示蒙层
  };
  if (!isQuoteField) {
    params.fieldValue = processRecordData(_module, fieldType, fieldExt);
  }

  return h(getComponent(fieldType), {
    params
  });
};
const currentSubRow = ref(); // 子表单当前列
// 创建子表单列配置
const createChildColumns = (item, index) => {
  const subEntityId = item?.setting?.fieldExt || null;
  const subFieldKey = item?.setting?.fieldKey || null;
  const colTypeChildren = [];

  item?.modules?.forEach((el, i) => {
    const childRender = (h, { row, rowIndex }) => {
      //如果是空数据显示行的话 直接设置透明度0的tr
      if (!Array.isArray(row) || !row?.length) {
        return h('div', { style: 'opacity: 0;' }, '-');
      }
      const subFormData = row?.find((r) => r?.setting?.fieldKey == item?.setting?.fieldKey)?.modules;
      const subRow = row?.find((r) => r?.setting?.fieldKey == item?.setting?.fieldKey);
      return h(
        'div',
        { class: 'child-table-container ' + (!subFormData?.length ? 'record-container' : '') },
        subFormData?.length > 0
          ? [
              ...subFormData.map((subFormRecord, subIndex) => {
                return h(
                  'p',
                  {
                    class: `${formTableStore.tableRequiredErrorData?.includes(props.modulesItem?.id + '__' + rowIndex + '__' + subIndex + '__' + el?.setting?.fieldKey) ? 'required-error' : ''} record-container child-table-container-second `,
                    onClick: (event) => {
                      currentSubRow.value = subIndex; // 子表单行
                      currentRow.value = rowIndex; // 主数据行

                      cellHandleClick(event, subFormRecord, el, true, subRow, subEntityId, subFieldKey);
                    }
                  },
                  createColumnConfig(subFormRecord, el, true, subEntityId)
                );
              })
            ]
          : emptyTextNode()
      );
    };
    const getColType = {
      title: (h, { col }) => <FhFromTableTitle col={col} fieldItem={el} />,
      colKey: el?.setting?.fieldKey || el?.value,
      fixed: item.businessData == 1 ? 'left' : undefined,
      width: [12, 25].includes(el?.setting?.fieldType) ? 250 : defaultWidth(el),
      cell: childRender,
      foot: 'summaryCell'
    };
    if (index == 0 && i == 0) {
      getColType.className = 'border-l-hide';
    }
    colTypeChildren.push(getColType);
  });
  return colTypeChildren;
};
const toTeleport = ref(null); //编辑容器
const openEdit = ref(false); //打开编辑
const contentStyle = ref({
  //编辑容器样式
  top: null,
  left: null,
  zIndex: 1001
});
//设置编辑参数
const setRecrodEditParams = ref(null);
// 组装字段编辑的配置
const getFieldConfig = (row, item, isSubForm, subRow = null, subEntityId = null, subFieldKey = null) => {
  // console.log('点击', row)
  // if(!Array.isArray(row)) return null
  const _module = row?.find((r) => r?.setting?.fieldKey == item?.setting?.fieldKey);
  console.log('_module', _module);
  console.log('_subRow', subRow);
  let LOGIC_ROLE_PERMISSION = null;
  let PERMISSION = null;

  if (isSubForm && subRow) {
    //子表单
    LOGIC_ROLE_PERMISSION = subRow?.LOGIC_ROLE_PERMISSION;
    PERMISSION = subRow?.PERMISSION;
  } else {
    LOGIC_ROLE_PERMISSION = _module?.LOGIC_ROLE_PERMISSION;
    PERMISSION = _module?.PERMISSION;
  }

  const { fieldType, fieldExt, isQuoteField } = getSetting(_module);
  let getFieldKey = _module?.setting?.fieldKey;
  if (isSubForm) {
    getFieldKey = `${subFieldKey}.${_module?.setting?.fieldKey}`;
  }
  const matchingItem = findComputedInfo(_module);
  const params = {
    col: { ...item?.setting },
    row: { ..._module, id: _module?.detailId || null, computedInfo: matchingItem, recordId: subRow?.detailId || null, businessData: isSubForm ? subEntityId : props.modulesItem.businessData },
    fieldValue: _module.fieldValue,
    fieldType: fieldType,
    subFieldFullKey: isSubForm ? getFieldKey : null, //子表单

    fieldName: _module?.setting?.fieldName,
    fieldExt: fieldExt,

    isSubForm: isSubForm,
    fieldKey: _module?.setting?.fieldKey,
    mainField: _module?.setting?.mainField,
    isRequired: isRequiredField(getFieldKey, PERMISSION, _module?.setting.isRequired),
    subEntityId: subEntityId,
    entity: props.modulesItem.businessData,
    sourceType: 2, //1:列表 2：详情
    //新建永远有可编辑权限
    permissions: props.type == 30 || props.copy == 1 ? 1 : LOGIC_ROLE_PERMISSION,
    PERMISSION: PERMISSION,
    tableType: props.modulesItem?.type //  31 查询记录， 30 关联记录
  };
  if (!isQuoteField) {
    params.fieldValue = processRecordData(_module, fieldType, fieldExt);
  }
  return params;
};

const currentRow = ref(); // 编辑的当前行

// 单元格点击事件
const cellHandleClick = async (event, row, item, isSubForm, subRow = null, subEntityId = null, subFieldKey = null) => {
  // 点击事件的处理逻辑

  const _module = Array.isArray(row) ? row?.find((r) => r?.setting?.fieldKey == item?.setting?.fieldKey) : null;

  if ((props.modulesItem?.type == 31 && _module?.detailId) || (props.modulesItem?.type == 30 && props.type == '30')) {
    //查询记录支持编辑 关联记录 仅在新建支持快捷编辑
    const { fieldType } = getSetting(_module);

    await nextTick();

    setRecrodEditParams.value = Array.isArray(row) ? getFieldConfig(row, item, isSubForm, subRow, subEntityId, subFieldKey) : null;

    openEdit.value = Array.isArray(row) ? true : false;

    itemFormData.value = {};
    if (props.modulesItem?.type == 30) {
      recordType.value = TABLE_TYPE.ASS_RECORD; // 关联记录
      const _itemFormData = getSendData([{ modules: row }]);
      itemFormData.value = _itemFormData;
    } else {
      recordType.value = TABLE_TYPE.RECORD; // 查询记录
    }
    let zIndex = 1001;

    let getAddPopup;
    if (document?.querySelectorAll('.fh-add-edit-popup')?.length) {
      getAddPopup = document?.querySelectorAll('.fh-add-edit-popup');
    } else {
      getAddPopup = document?.querySelectorAll('.page-clue-conversion');
    }

    // const getAddPopup = document?.querySelectorAll('.fh-add-edit-popup') || document?.querySelectorAll('.page-clue-conversion');
    if (getAddPopup && getAddPopup?.length > 0) {
      const drawerContent = getAddPopup[getAddPopup?.length - 1];

      zIndex = Number(getComputedStyle(drawerContent).zIndex) + 2;
      toTeleport.value = drawerContent.querySelectorAll('.fh-form-content-com')?.[0];
    }
    const clueHeader = document?.querySelectorAll('.conversion-header')?.[0]; // 线索转化

    const currentElement = event.currentTarget; //被点击元素
    const contentRect = currentElement?.getBoundingClientRect();
    const parentRect = toTeleport.value?.getBoundingClientRect();
    const clueRect = clueHeader?.getBoundingClientRect();

    let constentLeft = contentRect?.left - parentRect?.left - 2;
    const contentTop = clueRect ? contentRect?.top - 2 - clueRect.top : contentRect?.top - 2; // 兼容线索转化，减去头部高度
    let contentRight = null;
    let contentWidth = contentRect?.width + 4;

    if ([26, 18].includes(fieldType)) {
      //富文本，附件
      contentWidth = 300;
    }
    if (constentLeft + contentWidth >= parentRect.width) {
      //超出了
      contentRight = parentRect.width - constentLeft - contentRect?.width - 4;
      constentLeft = null;
    }

    contentStyle.value = {
      top: `${contentTop}px`,
      left: `${constentLeft}px`,
      right: `${contentRight}px`,
      width: contentWidth + 'px',
      zIndex: zIndex
    };
  }
};
//关闭编辑状态
const hideEdit = () => {
  contentStyle.value = {
    //编辑容器样式
    top: null,
    left: null,
    right: null,
    zIndex: 1001
  };
  openEdit.value = false;
};

eventListener('resize', hideEdit);
const defaultWidth = (item) => {
  const fieldType = item?.setting?.fieldType;
  const fieldName = item?.setting?.fieldName;
  return [8, 9].includes(fieldType) ? 160 : tools.getStrLen(fieldName) <= 6 ? 120 : tools.getStrLen(fieldName) > 10 ? 220 : tools.getStrLen(fieldName) * 20;
};
const emptyTextNode = () => {
  return h('span', { style: 'color: var(--color-text-3)' }, '-');
};

const tableColumns = computed(() => {
  const _modules = props.modulesItem.modules;
  const list = [];

  _modules?.forEach((item, index) => {
    const colType = {
      title: (h, { col }) => <FhFromTableTitle col={col} fieldItem={item} />,
      colKey: item?.setting?.fieldKey,
      fieldType: item?.setting?.fieldType,
      fieldExt: item?.setting?.fieldExt,
      ellipsis: true,
      tooltip: true,
      fixed: item.businessData == 1 ? 'left' : '',
      isRequired: item?.setting?.isRequired,
      width: item?.setting?.mainField || [12, 25].includes(item?.setting?.fieldType) ? 250 : defaultWidth(item),
      headerCellClass: item?.setting?.fieldType == 27 ? 'sub-form-table-border-font-color' : '',
      className: ({ rowIndex }) => {
        return `${index == 0 ? 'border-l-hide' : ''} ${formTableStore.tableRequiredErrorData?.includes(props.modulesItem?.id + '__' + rowIndex + '__' + item?.setting?.fieldKey) ? 'required-error' : ''}`;
      }
    };
    // if (index == 0) {
    //   colType.className = 'border-l-hide';
    // }
    let render = null;
    if (item?.setting?.fieldType == 27) {
      //子表单
      const childCols = createChildColumns(item, index);
      colType.children = childCols;
    } else {
      render = (h, { row, rowIndex }) => {
        return h(
          'div',
          {
            class: 'record-container',
            onClick: (event) => {
              currentRow.value = rowIndex;
              if (!Array.isArray(row)) {
                // 空数据禁止点击
                return;
              }
              cellHandleClick(event, row, item, false);
            }
          },
          createColumnConfig(row, item)
        );
      };
    }
    colType.cell = render;
    list.push({ ...colType, foot: 'summaryCell' });
  });
  if (buttons.value?.filter((v) => v.value.indexOf(':add') < 0)?.length > 0) {
    list.push({
      title: (h, { col }) => <FhFromTableTitle col={col} />,
      colKey: 'operation',
      fixed: 'right',
      cell: 'operation',
      colType: false,
      width: 180
    });
  }
  list.unshift({
    title: '',
    colKey: 'number',
    cell: 'number-slot-name',
    width: 46,
    align: 'center',
    fixed: 'left'
  });
  return list;
});

//退货单产品
const tableColumnsReturnOrder = computed(() => {
  let _modules = props.modulesItem.modules;
  const list = [];
  _modules = _modules.filter((v) => v.setting.fieldType !== 18);
  _modules?.forEach((item) => {
    const k = item?.setting?.fieldKey;
    const colType = {
      title: (h, { col }) => <FhFromTableTitle col={col} fieldItem={item} />,
      colKey: item?.setting?.fieldKey,
      ellipsis: false,
      fixed: item.businessData == 1 ? 'left' : '',
      isRequired: item.setting?.isRequired
    };
    let width = item.label.length <= 5 ? 120 : item.label.length * 30;
    if (k == 'customerDiscount' || k == 'standardPrice' || k == 'currencyType' || k == 'purchaseNum' || k == 'isInvoice' || k == 'isPayment' || k == 'serviceStartDate' || k == 'serviceEndDate') {
      width = 200;
    }
    list.push({ ...colType, width });
  });
  list.push({
    title: (h, { col }) => <FhFromTableTitle col={col} />,
    colKey: 'operation',
    fixed: 'right',
    cell: 'operation',
    colType: false,
    width: 180
  });
  return list;
});

// 参与了计算的字段--实时计算
const formulasChange = async () => {
  data.isRequesting = true;
  const getDetailModules = {
    id: props.modulesItem.id,
    businessData: props.modulesItem.businessData
  };
  const op = {
    viewId: props.viewId,
    entity: props.entity,
    formData: props.formData,
    detailList: data.form.customForm,
    type: props.type,
    id: props?.id || null, //这条数据的id
    from: 2,
    modulesItem: getDetailModules
  };
  data.isRequesting = false;
  const { detailList, errorMap } = await getComputeing(op);
  const getResult = detailList;
  calcErrorMap.value = errorMap;
  data.form.customForm = getResult;
  data.isRequesting = true;
};
watch(
  () => data.isRequesting,
  () => {
    if (data.isRequesting) {
      //计算字段已经计算完
      if (data.isSubmitFlag) {
        //点击了【确定】或者【确定并添加下一条】按钮
        getDetailList(cloneDeep(data.form.customForm));
        setLoading(false);
        if (data.isSubmitFlag == 2) {
          //确定
          toggleAdd();
        } else {
          data.isRequesting = true;
          data.isSubmitFlag = 0;
          //确定并添加下一条
          showFormTable.value = false;
          formRef.value?.resetFields();
          data.form.customForm.forEach((v) => {
            if ((v?.setting?.fieldType === 6 && v?.setting?.fieldKey != 'chargePerson') || v?.setting?.fieldType === 22) {
              v.setting['fv'] = [];
            }
            if (v?.setting?.fieldType === 18) {
              v.filesList = [];
              v.fieldValue = [];
            }
          });
          nextTick(() => {
            showFormTable.value = true;
          });
        }
      }
    }
  },
  { deep: true }
);
// 禾风特殊处理
//拆账金额
const paymentChange = () => {
  props.formData?.map((item) => {
    if (item?.modules) {
      item?.modules.forEach((list) => {
        if (list.type == 20) {
          if (list?.setting.fieldKey == 'amount_c64546') {
            //签单额
            data.signData = list.fieldValue;
          }
        }
      });
    }
  });
  data.form.customForm?.map((item) => {
    if (item.type == 20) {
      if (item?.setting.fieldKey == 'number_K4ZA4t') {
        //拆账比例
        const signAmount = data.form.customForm?.find((el) => el.setting?.fieldKey == 'amount_a5sm3f')?.fieldValue; //拆账金额
        // console.log('signAmount---',signAmount)
        item.fieldValue = data.signData && Number(signAmount / data.signData);
      }
      if (item?.setting.fieldKey == 'number_DHDhnk') {
        //结算金额
        const paymentData = data.form.customForm?.find((el) => el.setting?.fieldKey == 'number_K4ZA4t')?.fieldValue; //拆账比例
        const amountData = data.form.customForm?.find((el) => el.setting?.fieldKey == 'amount_a5sm3f')?.fieldValue; //拆账金额
        // console.log('signAmount---',signAmount)
        item.fieldValue = Number(paymentData * amountData);
      }
    }
  });
};
// 此处是处理商机阶段在新建/复制时默认选择第一个
const stageModulesItem = (item) => {
  if (item.value === 'opportunityStage' && data.operation == 1) {
    // 两种方案：：：：(产品确认使用2)
    // 1.如果是复制或者新增，赋值默认值
    // newObj.fieldValue = newObj.defaultValue;
    // 2.如果是复制或者新增，永远赋值第一个阶段
    const ext = item.setting.fieldExt;
    const parseExt = tools.isJSON(ext) && JSON.parse(ext) && JSON.parse(ext)?.length && JSON.parse(ext)?.[0]?.value;
    item.fieldValue = parseExt;
  }
  return item;
};
// 其他字段子组件回调
const updateModulesItem = async (index, getformatData, modulesItem) => {
  if (userInfo.orgId == hfOrgId && props.modules?.businessData == 201 && modulesItem?.setting?.fieldKey == 'input_AtwHxj') {
    //禾风特殊处理 （履约义务对象中的执行链接字段）
    data.form.customForm?.forEach((item) => {
      if (item.type == 20 && item?.setting?.fieldKey == 'number_fix8ik') {
        //执行进度（%）
        if (modulesItem?.fieldValue?.trim()) {
          item.fieldValue = 100;
        } else {
          item.fieldValue = 0;
        }
      }
    });
  }
  if (getformatData) {
    Object.assign(data.form.customForm, getformatData);
  } else {
    data.form.customForm[index] = modulesItem;
  }

  const findItem = props.modulesItem.modules?.find((el) => el?.setting?.fieldKey == modulesItem?.setting?.fieldKey);
  if (props.findCountFieldsList.includes(findItem?.setting?.fieldKey)) {
    //参与了计算
    formulasChange();
  }
  //更改时长单位(商机产品时长单位是：timeType，其他对象是：timeUnit)
  if (modulesItem?.setting?.fieldKey === 'timeUnit' || modulesItem?.setting?.fieldKey === 'timeType') {
    timeUnitChange(modulesItem.fieldValue);
  }
  //开服日期
  if (modulesItem?.setting?.fieldKey === 'serviceStartDate') {
    data.startDate = modulesItem?.fieldValue;
    // 停服日期
    const endDate = data.form.customForm?.find((i) => i?.setting?.fieldKey == 'serviceEndDate');
    if (endDate?.fieldValue && dayjs(endDate?.fieldValue).diff(modulesItem?.fieldValue, 'day') < 0) {
      // 给停服日期置空
      data.form.customForm?.map((v) => {
        if (v?.setting?.fieldKey === 'serviceEndDate') {
          v.fieldValue = '';
        }
      });
    }
  }

  if (modulesItem?.setting?.fieldType === 6 || modulesItem?.setting?.fieldType === 22) {
    //人员或部门
    data.form.customForm?.forEach((item, index) => {
      if (item.type == 20) {
        if (item?.setting?.fieldKey == modulesItem.value) {
          formRef.value?.clearValidate([`customForm.${index}.fieldValue`]);
        }
      }
    });
  }
  if (modulesItem?.setting?.fieldType == 12 && modulesItem?.setting?.fieldExt) {
    //查找关联字段---//针对引用字段做处理
    await setReferenceFieldValue([{ modules: data.form.customForm }], modulesItem);
    data.form.customForm = referenceFieldValue?.value?.[0]?.modules;
  }
  formRef.value?.validateField([`customForm.${index}.fieldValue`]);
};
// 退货单产品相关
const addOrderRef = ref();
//退货单产品-删除
const delReturnOrder = (index) => {
  const delItem = props.detailDataList[index].find((v) => v.fieldKey == 'orderProductId')?.fieldValue?.value;
  data.productList?.forEach((item, index) => {
    if (item.orderProductId?.value == delItem) data.productList.splice(index, 1);
  });
  const _detailDataList = getTableData();
  _detailDataList.splice(index, 1);
  const _ids = cloneDeep(formTableStore.tableAssociateIdData?.[props.modulesItem?.id] || []);
  formTableStore.setTableAssociateIdData(props.modulesItem?.id, _ids.splice(index, 1));
  callbackData(_detailDataList);
};
//添加明细
const addReturnOrder = () => {
  addOrderRef?.value.openDialog();
};

//退货标准价格,及折扣,退货数量,退货时长改变时
const updateList = async (val, rowIndex, record) => {
  data.rowIndex = rowIndex;
  const _detailDataList = props.detailDataList;
  if (props.findCountFieldsList.includes(record?.setting?.fieldKey)) {
    // 参与了计算的字段--实时计算
    const getDetailModules = {
      id: props.modulesItem.id,
      businessData: props.modulesItem.businessData
    };
    const op = {
      viewId: props.viewId,
      entity: props.entity,
      formData: props.formData,
      detailList: props.detailDataList[rowIndex],
      type: props.type,
      from: 2,
      modulesItem: getDetailModules
    };
    const { detailList, errorMap } = await getComputeing(op);
    const getResult = detailList;
    calcErrorMap.value = errorMap;
    _detailDataList[rowIndex] = getResult;
  }
  callbackData(_detailDataList);
};
//退货单修改币种(为了更新基本信息的币种)
const returnCurrencyType = () => {
  callbackData(props.detailDataList);
};
//关联表格回调同步更新到主表里
const callbackData = (callbackData) => {
  emit('updateDataList', {
    id: props.modulesItem.id,
    data: cloneDeep(callbackData)
  });
};
// 子表回调同步更新到关联表格中
const subFormModuleList = ref({});

//退货单--获取所选订单产品
const getProductList = async (selectPoductList) => {
  selectPoductList.forEach((item) => {
    const findItem = data.productList?.find((v) => v.orderProductId?.value == item.orderProductId?.value);
    if (!findItem) {
      item.id = ''; //新增的产品
      data.productList.push(item);
    }
  });

  data.productList?.forEach((item) => {
    if (item.fieldValues) {
      item.fieldValues?.forEach((list) => {
        item[list.fieldKey] = list.fieldValue;
      });
    }
  });
  let _detailDataList = setEditFormTable(props.modulesItem.modules, data.productList);
  // 参与了计算的字段--实时计算
  const getDetailModules = {
    id: props.modulesItem.id,
    businessData: props.modulesItem.businessData
  };
  const op = {
    viewId: props.viewId,
    entity: props.entity,
    formData: props.formData,
    detailList: _detailDataList,
    type: props.type,
    from: 3,
    modulesItem: getDetailModules
  };
  const { detailList, errorMap } = await getComputeing(op);
  calcErrorMap.value = errorMap;
  _detailDataList = detailList;
  callbackData(_detailDataList);
};

const updataSubFrom = (formCustomForm) => {
  formCustomForm?.forEach((item) => {
    if (item.type == 35) {
      subFormModuleList.value[item.id] = data.operation == 1 ? [] : item.modules;
    }
  });
};

// 新增--明细
const addEditRef = ref();
const productEntity = ref([7, 9, 11, 14, 32]);
const dataBak = ref(null); //临时备份编辑和复制的数据
const addDetail = () => {
  data.operation = 1;
  if ((!productEntity.value?.includes(parseInt(props.modulesItem?.businessData)) && !grayList?.['Layout:oldLayoutUsers']) || props.modulesItem?.type == 31) {
    //如果不是XX产品对象，新建走布局
    dataBak.value = null;
    const params = {
      id: '',
      type: 30,
      viewId: -1,
      entity: props.modulesItem?.businessData,
      associateKey: props.modulesItem?.type == 30 ? props.modulesItem?.associateKey : null,
      copy: 0,
      isAssociated: true,
      modulesItem: props.modulesItem
    };
    addEditRef.value?.open(params);
    return false;
  }
  data.setEditSubForm = 0; //给子表的参数
  data.recordIndex = '';
  data.form.customForm = cloneDeep(props.modulesItem.modules);
  updataSubFrom(data.form.customForm);
  /************** 获取主表单负责人复制到关联对象表格负责人字段中 start ******************/
  let _chargePerson = null;
  let _fv = null;
  props.formData?.forEach((fd) => {
    if (fd?.modules?.length) {
      fd?.modules?.forEach((fdm) => {
        if (fdm?.setting?.fieldKey == 'chargePerson') {
          _chargePerson = fdm?.fieldValue;
          _fv = cloneDeep(fdm?.setting?.fv);
        }
      });
    }
  });
  /************** 获取主表单负责人复制到关联对象表格负责人字段中 end ******************/
  data.form.customForm?.map((item) => {
    //复制默认负责人
    if (item?.setting?.fieldKey == 'chargePerson') {
      item.fieldValue = _chargePerson;
      item.setting.fv = _fv;
    }
    //客户折扣 默认是100
    if (item?.setting?.fieldKey == 'discount' || item?.setting?.fieldKey == 'customerDiscount') {
      //折扣
      item.fieldValue = 100;
    }
    if (item?.setting?.fieldKey == 'currencyType' || item?.setting?.fieldKey == 'currency') {
      //币种
      item.fieldValue = '1';
    }
    if (item?.setting?.fieldKey == 'purchaseNum' || item?.setting?.fieldKey == 'totality' || item?.setting?.fieldKey == 'num') {
      //购买数量 //总数量
      item.fieldValue = 1;
    }
  });

  //新增的时候调用一次计算
  formulasChange();
  toggleAdd(); //显示弹窗
};

// 编辑和复制时处理数据
const processingData = (record) => {
  record?.forEach((item) => {
    if (item.type == 35 && item.modules?.length) {
      item.modules?.forEach((k) => {
        k?.forEach((el) => {
          if (el?.setting?.fieldType == 6) {
            //6.人员
            const _list = el?.setting?.fv?.userList && Array.isArray(el?.setting?.fv?.userList) ? el?.setting?.fv?.userList : [];
            el.fieldValue =
              _list?.length > 0
                ? _list?.map((u) => {
                    return u?.userName || u?.name || '';
                  })
                : [];
          }
          if (el?.setting?.fieldType == 22) {
            //22:部门
            const _list = el?.setting?.fv?.departList && Array.isArray(el?.setting?.fv?.departList) ? el?.setting?.fv?.departList : [];
            el.fieldValue =
              _list?.length > 0
                ? _list?.map((u) => {
                    return u?.departmentName || u?.name || '';
                  })
                : [];
          }
        });
      });
    }
  });
  return record;
};

// 编辑--明细
const editDetail = (record, index) => {
  data.operation = 0;
  data.setEditSubForm = 1; //给子表的参数
  data.recordIndex = index;
  const updateRecord = processingData(cloneDeep(props.detailDataList[index]));
  console.log('updateRecord3333', updateRecord);
  if ((!productEntity.value?.includes(parseInt(props.modulesItem?.businessData)) && !grayList?.['Layout:oldLayoutUsers']) || props.modulesItem?.type == 31) {
    dataBak.value = record;
    //如果不是XX产品对象，编辑时判断是否有id，有id的话走id查询编辑逻辑，没有id则将当前数据传递过去进行编辑
    const params = {
      id: record?.[0]?.detailId,
      editRecord: record, //record?.[0]?.detailId ? undefined : record,
      type: record?.[0]?.detailId ? 40 : 30,
      viewId: -1,
      entity: props.modulesItem?.businessData,
      associateKey: props.modulesItem?.type == 30 ? props.modulesItem?.associateKey : null,
      copy: 0,
      isAssociated: true,
      modulesItem: props.modulesItem
    };
    addEditRef.value?.open(params);
    return false;
  }

  data.form.customForm = updateRecord;
  updataSubFrom(data.form.customForm);
  toggleAdd();
  if (userInfo.orgId == hfOrgId && props.modulesItem?.businessData == 215) {
    //禾风特殊处理
    paymentChange();
  }
};
// 删除api
const doDeleteRow = async (record, rowIndex) => {
  try {
    const params = {
      entity: props.modulesItem?.businessData,
      businessId: record?.[0]?.detailId
    };
    await deleteObj(params).then((res) => {
      if (res) {
        const _detailDataList = getTableData();
        _detailDataList.splice(rowIndex, 1);
        callbackData(_detailDataList);
      }
    });
  } catch (e) {
    console.log(e);
  }
};
//删除--明细
const removeDetail = (record, rowIndex) => {
  if (props.modulesItem?.type == 31) {
    //查找记录
    Modal.confirm({
      titleAlign: 'start',
      width: 400,
      simple: false,
      title: t('删除确认'),
      content: t('删除后该数据将不可恢复，是否确认？'),
      onOk: () => {
        doDeleteRow(record, rowIndex);
      }
    });
    return false;
  }
  const _detailDataList = getTableData();
  _detailDataList.splice(rowIndex, 1);
  const _ids = cloneDeep(formTableStore.tableAssociateIdData?.[props.modulesItem?.id] || []);
  _ids.splice(rowIndex, 1);
  formTableStore.setTableAssociateIdData(props.modulesItem?.id, _ids);
  formTableStore.setTableRequiredErrorData([]);
  callbackData(_detailDataList);
};
//复制--明细
const copyDetail = (record, index) => {
  data.operation = 1;
  data.setEditSubForm = 1; //给子表的参数
  data.recordIndex = '';
  const _r = processingData(cloneDeep(props.detailDataList[index]));
  if ((!productEntity.value?.includes(parseInt(props.modulesItem?.businessData)) && !grayList?.['Layout:oldLayoutUsers']) || props.modulesItem?.type == 31) {
    dataBak.value = record;
    //如果不是XX产品对象，复制时判断是否有id，有id的话走id查询复制逻辑，没有id则将当前数据传递过去进行复制
    const params = {
      id: record?.[0]?.detailId,
      editRecord: record,
      type: 30,
      viewId: -1,
      entity: props.modulesItem?.businessData,
      associateKey: props.modulesItem?.type == 30 ? props.modulesItem?.associateKey : null,
      copy: record?.[0]?.detailId ? 1 : 0,
      isAssociated: true,
      fromCopy: true,
      modulesItem: props.modulesItem
    };
    addEditRef.value?.open(params);
    return false;
  }
  _r.map((r) => {
    r['detailId'] = '';
    if (r?.type == 35) {
      //子表单
      r?.modules?.forEach((el) => {
        el?.forEach((item) => {
          item['detailId'] = '';
        });
      });
    }
  });
  data.form.customForm = cloneDeep(_r);
  toggleAdd(1);
};
// 新增的回调
const addCbFun = async (res) => {
  const _resMerge = cloneDeep(res);
  if (dataBak.value?.length) {
    //如果有存在备份，则对没有字段信息进行补充,调过计算字段和引用字段 && ![21, 24].includes(r?.setting?.fieldType)
    dataBak.value.forEach((db) => {
      const _findIndex = res?.findIndex((r) => r?.value && r?.value === db?.value);
      if (_findIndex === -1) {
        _resMerge.push(db);
      }
    });
  }
  const tableOperation = props.modulesItem?.tableOperation || {};
  if (tableOperation?.batchTableAdd === '1' && tableOperation?.checkTableData === '0') {
    const associateFieldValue = _resMerge?.find((v) => v?.setting?.fieldKey == batchAssociateModule.value?.setting?.fieldKey)?.fieldValue;
    if (associateFieldValue && isAssociateRepeat(associateFieldValue, data.recordIndex)) {
      //支持批量并且判断查重时校验查找关联id信息
      Message.warning(t('此项内容已存在，不允许重复创建'));
      //取消布局loading
      addEditRef.value?.cancelLoading?.();
      return false;
    }
  }
  //手动关闭新建弹窗
  addEditRef.value.visible = false;
  if (props.modulesItem?.type == 31 && _resMerge?.[0]?.detailId) {
    //查询记录
    await getComputedInfo(false, [_resMerge?.[0]?.detailId]);
    const permissions = await getPermission(_resMerge?.[0]?.detailId);
    _resMerge?.forEach((item) => {
      item['PERMISSION'] = permissions;
    });
  }

  getDetailList(_resMerge);
};

// 更新数据
const getDetailList = (selectPoductList) => {
  const _detailDataList = getTableData();
  // 整理子表单的值
  let _associateId = '';
  selectPoductList?.forEach((v) => {
    if (v.type == 35 && v.modules?.length && subFormModuleList.value[v?.id]) {
      v.modules = cloneDeep(subFormModuleList.value[v?.id]);
    }
    if (v?.setting?.fieldKey == batchAssociateModule.value?.setting?.fieldKey) {
      _associateId = v.fieldValue;
    }
  });
  const _ids = cloneDeep(formTableStore.tableAssociateIdData?.[props.modulesItem?.id] || []);
  let permissionIndex = 0;
  if (data.operation == 1) {
    //新增
    _detailDataList.unshift(selectPoductList);
    _ids.unshift(_associateId);
  } else {
    //编辑
    _detailDataList[data.recordIndex] = selectPoductList;
    _ids[data.recordIndex] = _associateId;
    permissionIndex = data.recordIndex;
  }
  callbackData(_detailDataList);
  formTableStore.setTableRequiredErrorData([]);
  nextTick(() => {
    //弹窗、布局新建或者编辑单行后，调用业务规则接口
    getBatchPermission([permissionIndex], _detailDataList);
    formTableStore.setTableAssociateIdData(props.modulesItem?.id, _ids);
  });
};
//添加明细：type：1销售合同添加报价单明细时 type：2销售订单添加报价单明细时 type：3销售订单添加合同明细时
const updateDetail = (type) => {
  let id = null;
  if (type == 1 || type == 2) {
    if (!data.priceSheetId) {
      Message.warning(t('请选择报价单') + '！');
      return;
    }
    id = data.priceSheetId;
  } else {
    if (!data.contractId) {
      Message.warning(t('请选择销售合同') + '！');
      return;
    }
    id = data.contractId;
  }
  getPriceSheetProduct(id, type);
};

//获取相关明细  //type：1销售合同添加报价单明细时 type：2销售订单添加报价单明细时 type：3销售订单添加合同明细时
const getPriceSheetProduct = async (id, type) => {
  data.tableloading = true;
  const params = {
    id: id,
    detailEntityId: type == 1 || type == 2 ? 6 : 8, //区分是从报价单还是从合同明细添加的明细（对应的entityId）
    entityId: type == 2 || type == 3 ? 10 : 8 //上传当前对象entityId
  };
  try {
    const res = await publicService.getDetailAutoFill(params);
    if (!res.error) {
      const records = cloneDeep(res?.result);
      records?.forEach((item) => {
        if (item?.productName && item?.productId) {
          item['productId'] = {
            label: item.productName,
            value: item.productId,
            business: 4,
            id: item.originBusinessId
          };
        }
        item.newOriginBusinessId = item.originBusinessId + '-' + item.sourceId; //（来源entityId和来源数据id才是唯一值）
      });
      let _detailDataList = getTableData();
      // 确保detailDataList和records都已定义
      if (!_detailDataList || !records) return;
      // 初始化一个Set来存储已处理的originBusinessId，以避免重复处理
      const processedIds = new Set();
      // 遍历detailDataList
      _detailDataList?.forEach((item) => {
        const itemId = item[0].newOriginBusinessId;

        // 如果该originBusinessId尚未处理
        if (!processedIds.has(itemId)) {
          const matchingRecord = records?.find((record) => record.newOriginBusinessId === itemId);

          // 如果在records中找到了匹配项
          if (matchingRecord) {
            // 使用setEditFormTable处理匹配到的记录，并替换到当前位置
            _detailDataList.splice(_detailDataList.indexOf(item), 1, ...setEditFormTable(props.modulesItem.modules, [matchingRecord]));
            processedIds.add(itemId); // 标记该originBusinessId已处理
          }
        }
      });
      // 收集未在detailDataList中找到匹配的records项
      const unmatchedRecords = records?.filter((record) => !processedIds.has(record.newOriginBusinessId));
      // 将未匹配的项使用setEditFormTable添加到前面
      unmatchedRecords?.forEach((record) => {
        _detailDataList.unshift(...setEditFormTable(props.modulesItem.modules, [record]));
      });

      // 参与了计算的字段--实时计算
      const getDetailModules = {
        id: props.modulesItem.id,
        businessData: props.modulesItem.businessData
      };
      const op = {
        viewId: props.viewId,
        entity: props.entity,
        formData: props.formData,
        detailList: cloneDeep(_detailDataList),
        type: props.type,
        from: 3,
        modulesItem: getDetailModules
      };
      // const getResult = await getComputeing(op);
      const { detailList, errorMap } = await getComputeing(op);
      calcErrorMap.value = errorMap;
      _detailDataList = cloneDeep(detailList);
      data.tableloading = false;
      callbackData(_detailDataList);
    } else {
      data.tableloading = false;
      Message.error(res.error?.msg || t('操作失败'));
    }
  } catch (e) {
    data.tableloading = false;
    Message.error(e.message || e.statusText || t('操作失败'));
  }
};
/***************
 * 产品相关
 **************/
const choosePrice = () => {
  data.form.customForm?.map((item) => {
    if (item?.setting?.fieldKey === 'productId' || item?.setting?.fieldKey === 'product') {
      data.productId = item?.fieldValue || '';
    }
  });
  if (!data.productId) {
    Message.error(t('tips.changeProduct'));
    return;
  }
  priceRef.value.priceShow(data.productId); //显示价格弹窗
};
// 更新明细相关字段
const updateCustomForm = (record) => {
  data.form.customForm?.map((item, index) => {
    if (item?.setting?.fieldKey == 'currency' || item?.setting?.fieldKey == 'currencyType') {
      //币种
      item.fieldValue = record && record?.currency ? String(record?.currency) : item.fieldValue;
    }
    if (item?.setting?.fieldKey == 'timeType' || item?.setting?.fieldKey == 'timeUnit') {
      //时长单位
      item.fieldValue = record && record?.timeType ? String(record?.timeType) : item.fieldValue;
    }
    if (item?.setting?.fieldKey == 'unit' || item?.setting?.fieldKey == 'specificationUnit') {
      //规格
      item.fieldValue = record && record?.unit ? String(record?.unit) : item.fieldValue;
    }
    if (item?.setting?.fieldKey == 'price' || item?.setting?.fieldKey == 'standardPrice') {
      //标准价格
      item.fieldValue = record && record?.price ? record?.price : item.fieldValue;
      if (item.fieldValue) {
        formRef.value?.clearValidate([`customForm.${index}.fieldValue`]);
      }
      if (props.findCountFieldsList.includes(item?.setting?.fieldKey)) {
        // 参与了计算的字段--实时计算
        formulasChange();
      }
    }
  });
};

//更新产品价格
const updatePrice = () => {
  priceRef.value.clearChecked(); //清空价格选中
  props.modulesItem.modules?.map((item) => {
    if ((item?.setting?.fieldKey == 'price' || item?.setting?.fieldKey === 'standardPrice') && props.findCountFieldsList.includes(item?.setting?.fieldKey)) {
      // 参与了计算的字段--实时计算
      formulasChange();
    }
  });
};

const providedMethods = {
  updateCustomForm: updateCustomForm
};

provide('methods', providedMethods);
// 切换产品名称
const productChange = async (index, v, e) => {
  data.productId = v;
  let modulesItem = {};
  if (data.productId) {
    // 把一些有关产品的字段都清空(价格，币种，时长单位，规格单位)
    const fieldKey = ['price', 'standardPrice', 'productType', 'currency', 'currencyType', 'timeUnit', 'timeType', 'unit', 'specificationUnit', 'buyTime', 'taxRate'];
    data.form.customForm.map((item) => {
      if (fieldKey.includes(item?.setting?.fieldKey)) {
        item.fieldValue = null;
      }
      if (item?.setting?.fieldKey == 'productId' || item?.setting?.fieldKey == 'product') {
        //产品名称
        item.customValue = cloneDeep(e?.length > 0 ? e[0] : { label: '', value: '' });
        modulesItem = item;
      }
      if (item?.setting?.fieldKey == 'productType') {
        //产品类型
        item.fieldValue = e[0]?.productType;
      }
      if (item?.setting?.fieldKey == 'taxRate') {
        //税率 百分比
        if (item.setting?.fieldType == 23) {
          item.fieldValue = (Number(e[0]?.taxRate) && tools.getPercentage(Number(e[0]?.taxRate))) || '';
        } else {
          item.fieldValue = Number(e[0]?.taxRate);
        }
      }
    });
    priceRef.value.clearChecked(); //清空价格选中
    priceRef.value.getProductPrice(data.productId); //获取产品价格
    if (modulesItem?.setting?.fieldType == 12 && modulesItem?.setting?.fieldExt) {
      //查找关联字段---//针对引用字段做处理
      await setReferenceFieldValue([{ modules: data.form.customForm }], modulesItem);
      data.form.customForm = referenceFieldValue?.value?.[0]?.modules;
    }
    formulasChange(); //调用一次计算
  }
  formRef.value?.validateField([`customForm.${index}.fieldValue`]);
};
//时长单位变更时，改变购买时长的非必填状态
const timeUnitChange = (timeUnit) => {
  data.form.customForm?.map((item) => {
    if (item?.setting?.fieldKey == 'buyTime') {
      item.isRequired = false;
    }
  });
  if (timeUnit) {
    data.form.customForm?.map((item) => {
      if (item?.setting?.fieldKey == 'buyTime') {
        item.isRequired = true;
      }
    });
  }
};
// 购买时长的校验规则
const buyTimeRules = (field, fieldName) => {
  const sign = data.form.customForm?.findIndex((item) => item?.setting?.fieldKey === 'timeUnit' && item.fieldValue);
  if (sign !== -1) {
    return { required: true, message: `请填写${fieldName}` };
  } else {
    formRef.value?.clearValidate([field]);
    return {};
  }
};

data.timeUnit = computed(() => data.form.customForm?.filter((i) => i?.setting?.fieldKey == 'timeUnit')[0]?.fieldValue); //时长单位
data.timeList = computed(() => data.form.customForm?.filter((i) => i?.setting?.fieldKey == 'timeUnit')[0]?.setting?.fieldExt); //时长的下拉数据
//购买时长
const buyTimeChange = () => {
  props.modulesItem.modules?.map((item) => {
    if (item?.setting?.fieldKey == 'buyTime' && props.findCountFieldsList?.includes(item?.setting?.fieldKey)) {
      // 参与了计算的字段--实时计算
      formulasChange();
    }
  });
};
// 添加、编辑弹窗明细的显隐
const isAdd = ref(false);
const showNextButton = ref(true);
const toggleAdd = async (i) => {
  showNextButton.value = !i;
  isAdd.value = !isAdd.value;
  if (isAdd.value) {
    data.isRequesting = true; //计算字段是否计算完
    data.isSubmitFlag = 0; //是否点击确定
  }
};
// 手机号校验
const mobileRules = [
  { required: true, message: t('tips.phoneNumber') },
  { match: phoneRegexp, message: t('tips.phoneRules') }
];

//初始化编辑数据到modules
const setEditTableData = () => {
  if (props.modulesItem.type == 30 && props.modulesItem?.modules) {
    //组件表格
    if (props.type == 40 || props.copy == 1) {
      //编辑
      const recordList = props.modulesItem?.fieldValue?.records;
      if (props.modulesItem?.businessData == 14) {
        //退货单产品
        data.productList = recordList || [];
      }
    }
  }
};
//合同/订单中切换报价单,订单中切换合同需要有关明细清除
const setDetailProduct = async (entity) => {
  const tempDetailDataList = [];
  let _detailDataList = getTableData();
  _detailDataList?.forEach((item) => {
    if (item[0]?.detailEntityId != entity) {
      tempDetailDataList.push(item);
    }
  });
  _detailDataList = tempDetailDataList;
  callbackData(_detailDataList);
};

const initFormAssociateIds = () => {
  const _ids = [];
  props.detailDataList?.forEach((td) => {
    const _findModule = td?.find((tdf) => tdf?.setting?.fieldKey == batchAssociateModule.value?.setting?.fieldKey);
    if (_findModule) {
      _ids.push(_findModule?.fieldValue || '');
    }
  });
  formTableStore.setTableAssociateIdData(props.modulesItem?.id, _ids);
};

onMounted(() => {
  initCustomerId();
  //初始化编辑数据到modules
  setEditTableData();
  getComputedInfo(true);
  //初始化批量编辑需要使用的主表单的字段
  if (props.modulesItem?.tableOperation?.batchTableAdd === '1') {
    const _usedFieldKey = [];
    props.modulesItem?.tableOperationConditions?.children?.forEach((toc) => {
      toc?.children?.forEach((tocc) => {
        //如果选择条件类型为=字段 且字段不为空，且字段为当前主表单的字段，并且只下钻了1级，则需要取主表单的字段值
        if (tocc?.conditionType == 1 && tocc?.value && tocc?.value.startsWith(props.entity)) {
          const _conditionFieldArr = tocc?.value?.split('.');
          if (_conditionFieldArr?.length == 2) {
            _usedFieldKey.push(_conditionFieldArr[1]);
          }
        }
      });
    });
    bulkUsedFieldKey.value = _usedFieldKey;
    initFormAssociateIds();
  }
});

defineExpose({
  setDetailProduct
});
</script>
<style scoped lang="less">
@import './fh-form-table.less';
</style>
<style lang="less">
.add-table-modal {
  .arco-modal-body {
    min-height: 300px;
    max-height: 750px;
  }
}

.sub-form-content {
  //子表单容器
  .system-form-item {
    display: flex;
    flex-direction: column;
  }
}
</style>
